export default {
  jobMatching: {
    frequency: "Frequency",
    salaryAmount: "Amount",
    noCountries: "No more countries match your search.",
    allLevels: "Leave empty to include all levels.",
    searchValidationError:
      "Check your salary, currency and search filters before saving.",
    jobPreferences: "Job preferences",
    employerPreferences: "Employer preferences",
    companySettings: "Company settings",
    countries: "Countries",
    countryHelp: "Use your main CV’s country, or choose where you want to work.",
    mainCvCountry: "Main CV country",
    searchCountries: "Search countries",
    relocationHelp: "Remote jobs follow these countries too. Alerts require a known job location.",
    cities: "Cities (optional)",
    excludedRoles: "Roles to exclude",
    excludedCompanies: "Companies to exclude",
    commaSeparated: "Separate entries with commas",
    seniority: "Seniority",
    minimumSalary: "Minimum salary (optional)",
    currency: "Currency, for example AED",
    monthly: "Monthly",
    yearly: "Yearly",
    unknownSalary: "Include jobs with no comparable salary listed",
    workArrangement: "Work arrangement",
    alerts: "Job alerts",
    alertHelp: "Get up to three matching jobs in each digest. Alerts need app notifications enabled.",
    globalPushOff:
      "Push notifications are off in notification settings. Job alerts will remain paused until you enable them.",
    enableAlerts: "Enable job alerts",
    daily: "Daily",
    weekly: "Weekly",
    hour: "Delivery hour (0–23)",
    timezone: "Time zone",
    threshold: "Minimum match score (55–100%)",
    useDeviceTimezone: "Use my device time zone",
    editSearch: "Edit job search preferences",
    chooseMainCv: "Manage my main CV",
    retry: "Retry",
    save: "Save alert settings",
    saved: "Alert settings saved",
    saveError:
      "Could not save. Check the hour, time zone and match score, then try again.",
    levels: {
      entry: "Entry level",
      mid: "Mid level",
      senior: "Senior",
      lead: "Lead",
      manager: "Manager",
      director: "Director",
      executive: "Executive",
      internship: "Internship",
    },
  },


  // Chat
  chat: {
    title: "Chats",
    newChat: "+ New",
    /** Icon-only new-chat button in the web chat column (tooltip + a11y name). */
    newChatAction: "New chat",
    emptyState: "Start a conversation with your AI career assistant",
    emptyTitle: "How can I help?",
    emptySubtitle: "Ask me about your career, CV, or job search",
    inputPlaceholder: "Message Tabbio...",
    untitledThread: "Untitled chat",
    deleteThreadTitle: "Delete chat?",
    deleteThreadMessage: "Delete “{{title}}”? This cannot be undone.",
    deleteThreadConfirm: "Delete",
    deleteThreadMenuLabel: "Delete {{title}}",
    deleteThreadSuccess: "Chat deleted",
    deleteThreadFailed: "Could not delete chat",
    deleteThreadFailedMessage: "Your chat was restored. Please try again.",
    clearAllHistoryAction: "Clear all chats",
    clearAllHistoryTitle: "Clear all chats?",
    clearAllHistoryMessage:
      "This will permanently delete all of your chats. This cannot be undone.",
    clearAllHistoryConfirm: "Clear all",
    clearAllHistoryProgress: "Clearing chats…",
    clearAllHistorySuccess: "All chats cleared",
    clearAllHistoryPartial: "Some chats could not be deleted",
    clearAllHistoryFailed: "Could not clear chats",
    editPrompt: "Edit",
    editMessageTitle: "Edit message",
    editMessagePlaceholder: "Edit your message",
    cancelEdit: "Cancel",
    saveEdit: "Save",
    editSendFailedTitle: "Couldn't save edit",
    editSendFailedMessage: "Please try again.",
    suggestions: {
      buildCV: "Match me with jobs",
      buildCVSub: "based on my profile",
      findJobs: "Find jobs",
      findJobsSub: "search all listings",
      tailorCV: "Tailor my CV",
      tailorCVSub: "for a specific role",
      prepInterview: "Practice an interview",
      prepInterviewSub: "with role-specific questions",
      findRoles: "Find roles that match me",
      linkedinPost: "Write this week's LinkedIn post",
      industryBriefing: "Send me a daily industry briefing",
    },
    feedback: {
      goodResponse: "Good response",
      badResponse: "Not helpful",
      updateFailed: "Could not save your feedback. Please try again.",
    },
    cvOnePage: {
      enabledTitle: "One-page mode is on",
      enabledBody:
        "The PDF will use a compact layout when needed. If it already fit on one page, it may look unchanged.",
      alreadyEnabledTitle: "One-page mode was already on",
      alreadyEnabledBody: "No additional layout change was needed.",
      disabledTitle: "One-page mode is off",
      disabledBody: "The PDF will use the standard layout.",
      alreadyDisabledTitle: "One-page mode was already off",
      alreadyDisabledBody: "No layout change was needed.",
      viewCv: "View CV",
      cardLabel: "CV layout",
    },
    // Tag shown inside the composer naming the screen the agent will act on.
    pageTag: {
      cv: "CV",
      cvTailored: "Tailored CV",
      cvHub: "My CVs",
      jobs: "Jobs",
      jobDetail: "This job",
      skills: "Skills",
      automation: "Automation",
      connectors: "Connectors",
      memory: "Memory",
      messages: "Messages",
      notifications: "Notifications",
      analytics: "Analytics",
      applicationStudio: "Career tools",
    },
    // Per-screen intros for the web agent chat column. Several phrasings of
    // the same message per screen so repeat visits read differently; one is
    // picked per visit (see route-context-intros.ts). Keep en and ar in sync.
    routeIntro: {
      cvHub: {
        m1: "Your CVs are here. Would you like to create a new one or choose one to work on?",
        m2: "Tell me the role you have in mind, and we can choose which CV to use.",
        m3: "We can create a CV, compare your versions, or organize your collection.",
        chips: {
          create: "Create a CV",
          choose: "Choose a CV for a role",
          manage: "Explore my CVs",
        },
      },
      cv: {

        m1: "What would you like to improve in your CV?",
        m2: "We can work on your summary, experience, skills, or a version for a specific job.",
        m3: "Want to make this CV clearer and stronger?",
        m4: "Would a recruiter notice your best work quickly? Let's check.",
        m5: "Choose a section below, or tell me what you want to change.",
        chips: {
          rewriteSummary: "Rewrite my summary",
          strongerBullets: "Make my bullets stronger",
          gaps: "What's missing?",
          tailor: "Tailor for a job",
        },
      },
      cvTailored: {
        m1: "Want to adjust this CV for the role?",
        m2: "We can compare it with your main CV or make it more focused.",
        m3: "Changes here stay in this tailored version. What should we improve?",
        m4: "Want to check the keywords or fit it onto one page?",
        m5: "What would you like to change in this tailored CV?",
        chips: {
          matchKeywords: "Match the job's keywords",
          compare: "Compare to my main CV",
          tighten: "Cut it to one page",
        },
      },
      jobs: {
        m1: "What kind of job are you looking for?",
        m2: "Tell me the role, location, or work setup you want.",
        m3: "Want to narrow this list by fit, location, salary, or work mode?",
        m4: "Not seeing the right roles? Tell me what to search for.",
        m5: "Should we rank these jobs or start a new search?",
        chips: {
          remoteGcc: "Remote roles in the GCC",
          bestMatches: "Which fit me best?",
          recent: "Posted this week",
          easyApply: "Apply directly",
        },
      },
      jobDetail: {
        m1: "Want to see how well this job fits your profile?",
        m2: "We can compare this role with your experience and spot any gaps.",
        m3: "Want to tailor your CV or practise for the interview?",
        m4: "Interested in this role? I can prepare the application for you to review.",
        m5: "What would you like to do with this job?",
        chips: {
          fit: "How well do I fit?",
          tailor: "Tailor my CV for this",
          apply: "Prepare my application",
          prep: "Prep me for the interview",
        },
      },
      skills: {
        m1: "What do you want to improve?",
        m2: "Find a skill for your CV, interview, or job search.",
        m3: "Choose a skill below, or tell me what you need help with.",
        m4: "Want to see which CV skills are available?",
        m5: "Not sure where to start? Tell me your goal and I'll suggest a skill.",
        chips: {
          recommend: "Recommend a skill",
          run: "Show CV skills",
          explain: "What are skills?",
        },
      },
      automation: {
        m1: "What would you like Nova to handle for you?",
        m2: "Review your current automations or prepare a new draft.",
        m3: "Want to check recent activity or create a weekly job search?",
        m4: "Tell me what to look for and how often. I'll create a draft for you to review.",
        m5: "Nothing runs until you approve it. What would you like to set up?",
        chips: {
          setUp: "Draft auto-apply",
          review: "Review activity and rules",
          rules: "Draft a weekly job search",
        },
      },
      connectors: {
        m1: "Which app would you like to connect?",
        m2: "Ask what each connector does before you set it up.",
        m3: "Want to use Tabbio with ChatGPT, Claude, Gemini, or Grok?",
        m4: "Need help connecting an available AI assistant?",
        m5: "Choose a connector below, or ask which one suits you.",
        chips: {
          which: "Recommend a connector",
          linkedin: "Connect an AI assistant",
        },
      },
      memory: {
        m1: "Want to check what I remember about your career?",
        m2: "You can review or correct anything here.",
        m3: "Is anything here out of date?",
        m4: "This information shapes the advice you get. What should we check?",
        m5: "Tell me what you want to add, change, or remove.",
        chips: {
          what: "What do you remember?",
          correct: "Correct my target role",
        },
      },
      messages: {
        m1: "Want to catch up on your conversations?",
        m2: "I can find a person, open a conversation, or prepare a reply for your approval.",
        m3: "Which conversation would you like to review?",
        chips: {
          unread: "Show unread conversations",
          findPerson: "Find someone",
          draftReply: "Help me reply",
        },
      },
      notifications: {
        m1: "Want to review what needs your attention?",
        m2: "I can show unread notifications or help manage your notification settings.",
        m3: "Should we clear completed alerts or review delivery preferences?",
        chips: {
          unread: "Show unread alerts",
          markAllRead: "Mark all as read",
          preferences: "Review preferences",
        },
      },
      analytics: {
        m1: "Want to see how your public CV is performing?",
        m2: "I can summarize your CV reach and where recent views came from.",
        m3: "Which CV performance period would you like to review?",
        chips: {
          reach: "Show 30-day reach",
          sources: "Where views came from",
          compare: "Compare my CVs",
        },
      },
      applicationStudio: {
        m1: "Which career tool would you like to use?",
        m2: "I can score a CV, draft a cover letter, prepare an interview, or build an application pack.",
        m3: "Tell me the job and I can prepare the right career material for you to review.",
        chips: {
          score: "Score my CV",
          coverLetter: "Draft a cover letter",
          interview: "Prepare an interview",
          saved: "Show saved results",
        },
      },
    },
    followUps: {
      jobs: {
        applyFirst: "Prepare the first application",
        refineSearch: "Change my search",
      },
      cv: {
        tailorForJob: "Tailor this CV for a job",
        browseSkills: "Show me CV skills",
        exportPdf: "Export as PDF",
      },
      profile: {
        reviewProfile: "Review my profile",
        addExperience: "Add another experience",
      },
      applications: {
        trackStatus: "Track this application",
        viewOthers: "View my other applications",
      },
      candidates: {
        viewTop: "View the top candidate",
        shortlist: "Shortlist this candidate",
      },
    },
    postOnboardingWelcome: {
      title: "Welcome to Tabbio",
      subtitle:
        "Your career agent is ready. Start free, then use chat and Apps to move your next career task forward.",
      continueCta: "Continue free",
      close: "Close welcome",
      features: {
        chatApply: {
          title: "Apply by chatting",
          body: "Tell Tabbio the role. It can prepare the next step and ask before anything is sent.",
        },
        tailoredCv: {
          title: "Tailored CVs",
          body: "Turn your profile into a focused CV for each job.",
        },
        webCv: {
          title: "CV ready",
          body: "Share a clean profile recruiters can open anywhere.",
        },
        jobMatches: {
          title: "Job matches and alerts",
          body: "Get matched roles and notifications when something fits.",
        },
      },
    },
    postOnboardingProductTour: {
      nextCta: "Next",
      openMenuCta: "Open menu",
      openAppsCta: "Open Apps",
      skipCta: "Skip Tour",
      steps: {
        chat: {
          title: "Ask Tabbio",
          body: "Start with one career task in chat.",
        },
        apps: {
          title: "Find Apps",
          body: "Apps is where Gmail, Zapier, Make, calendar, and MCP connections live.",
        },
        menu: {
          title: "Open the menu",
          body: "Use the drawer anytime to jump into CV, shared CVs, jobs, Automation, Apps, messages, and settings.",
        },
      },
    },
  },

  // Browser extension connect handoff (/extension/connect)
  extensionConnect: {
    title: "Connect Tabbio Apply?",
    body: "The extension will be able to read your CVs and profile so it can tailor and fill applications for you.",
    approve: "Connect extension",
    connecting: "Connecting",
    done: "Connected. You can close this tab.",
    close: "Close tab",
    loading: "Loading",
    grantFailed: "Could not start the connection. Try again.",
    notInstalled:
      "We could not reach the extension. Make sure it is installed and enabled, then try again.",
    unknownExtension: "This extension is not recognised.",
    unknownExtensionBody:
      "For your safety Tabbio only connects to the extension it published. Install Tabbio Apply from the Chrome Web Store and open the panel again.",
    subtitle:
      "Tabbio Apply reads job pages you open and fills applications with your details. It needs access to your Tabbio account to do that.",
    account: "Connecting this account",
    grantsTitle: "What the extension will be able to do",
    grants: {
      cvs: {
        title: "Read your CVs",
        body: "So it can tailor one to the job you are looking at and attach it for you.",
      },
      profile: {
        title: "Read your profile",
        body: "Your name, contact details and experience, so you never retype them into a form again.",
      },
      control: {
        title: "It never submits an application",
        body: "Every field is shown to you before it is filled, and you press submit yourself. Disconnect any time from Settings.",
      },
    },
    doneTitle: "You are connected",
    notNow: "Not now",
    retry: "Try again",
    extensionLabel: "Extension",
    desktopOnlyTitle: "Open this on your computer",
    desktopOnlyBody:
      "The Tabbio Apply extension runs in a desktop browser. Open this link there to connect your account.",
  },

  // Tabbio CLI browser sign-in handoff (/cli/connect). `tabbio login` opens
  // this page; approving sends a one-time code to the CLI's loopback listener.
  cliConnect: {
    title: "Connect Tabbio CLI",
    subtitle:
      "The Tabbio command-line tool is asking to sign in to your account from a computer.",
    loading: "Loading",
    account: "Signing in as",
    deviceLabel: "Computer",
    unknownDevice: "Name not provided",
    grantsTitle: "What you are allowing",
    grants: {
      access: {
        title: "Full access to your Tabbio account",
        body: "From that computer, the CLI can do anything you can do here: read and edit your CVs and profile, search and apply for jobs, send messages and run your agent. Actions that need your approval still ask you first.",
      },
      revoke: {
        title: "You can disconnect it at any time",
        body: "Run tabbio logout on that computer to disconnect it. If you lose the computer, change your password: that signs out every device at once.",
      },
      origin: {
        title: "Only approve a request you started",
        body: "Approve only if you just ran tabbio login yourself. If you did not, cancel and nothing is shared.",
      },
    },
    destinationLabel: "Your one-time sign-in code will be sent to",
    destinationHint:
      "A local address on this computer where the CLI is waiting. It only works in a browser on the same computer where you ran tabbio login.",
    approve: "Approve and connect",
    connecting: "Connecting",
    retry: "Try again",
    cancel: "Cancel",
    grantFailed: "Could not start the connection. Try again.",
    doneTitle: "Return to your terminal",
    done: "Tabbio CLI finishes signing in on your computer. You can close this tab. If your terminal stopped waiting, run tabbio login again.",
    close: "Close tab",
    cancelledTitle: "Connection cancelled",
    cancelled: "Nothing was shared with the CLI. You can close this tab.",
    invalidTitle: "This sign-in link is not valid",
    invalidBody:
      "Some of the details the CLI adds to it are missing or were changed. Run tabbio login again in your terminal to get a fresh link.",
    impersonationTitle: "Support sessions cannot connect the CLI",
    impersonationBody:
      "You are viewing someone else's account for support. Sign in with your own account to connect Tabbio CLI.",
    desktopOnlyTitle: "Open this on your computer",
    desktopOnlyBody:
      "This link finishes signing in to Tabbio CLI. Open it in a browser on the computer where you ran tabbio login.",
    copyLink: "Copy link",
    linkCopied: "Link copied",
  },

  // CV
  cv: {
    identityVerified: "Identity name verified with UAE PASS; career claims are self-reported",
    review: {
      openEditor: 'Edit this CV', openSharing: 'Share and export',
      compareCareerFacts: 'Compare with my current career facts', hideCareerFacts: 'Hide career facts', currentCareerFacts: 'Current career facts',
      libraryPurpose: 'Purpose: {{purpose}}', generalPurpose: 'General career CV',
      libraryReview: 'Review, languages and history', publicWebCv: 'Public Web CV', publishedLink: 'Published CV link', privateDraft: 'Private',
      factsChangedShort: 'Career facts changed · review this CV',
      factsChanged: 'Career facts changed since this version was reviewed. Compare them with this CV and its languages. Tailored drafts and past submissions keep their saved content.',
      historyNotice: 'Choose a saved version to read it. Compare two versions before deciding what to restore.',
      historyEntry: '{{actor}} · {{action}} · {{date}}',
      historyActor: { user: 'Owner', collaborator: 'Collaborator', agent: 'AI assistant', skill: 'Career tool', health: 'CV Health', partner: 'Partner', system: 'System' },
      historyAction: { observed: 'Existing content recorded', restored: 'Saved version restored', approved: 'Version approved', translationAccepted: 'Translation accepted', created: 'CV created', imported: 'CV imported', health: 'Health changes saved', generated: 'Wording generated', edited: 'Draft edited' },
      chooseComparison: 'Choose a second version to compare', selectVersion: 'Choose the first version',
      partialSnapshot: 'This older snapshot shows only wording saved in this CV. Inherited profile details were not recorded.',
      selectedHistory: 'First saved version', comparisonHistory: 'Second saved version',
      before: 'First version', after: 'Second version', moreHistory: 'Load older versions',
      restoreNotice: 'Restore this saved content as a new draft. Approved versions, public links and past submissions keep their saved content.',
      restoreVersion: 'Restore as a new draft',
      "transitionPending": "Your existing shared version is being preserved before the new release controls are enabled. Your current links still work.",
      "approvedVersion": "Approved version to publish",
      "compareSource": "Compare with the current source",
      "hideSource": "Hide source comparison",
      "currentSource": "Current source CV",
      "capturedSource": "Source used for this proposal",
      "proposedVersion": "Proposed wording",
      "legacyObservedAt": "Existing version recorded on {{date}}",
      "title": "Review and releases",
      "intro": "Review this CV and its saved versions in one place.",
      "unavailable": "Review is not available for this CV yet.",
      "original": "Original CV",
      "locale": {
        "en": "English",
        "ar": "Arabic"
      },
      "loading": "Loading CV review",
      "failed": "This change could not be saved. Your draft is still here. Try again.",
      "conflict": "This CV changed. Keep your edits here, or discard them and reload the latest version.",
      "blank": "Not provided",
      "draftVersion": "Draft version {{version}}",
      "sourceChanged": "The source changed, or this edition has no recorded source. Compare the facts before confirming it.",
      "sourceAcknowledgment": "I compared this edition with the current source and reviewed the differences.",
      "editEdition": "Edit this edition",
      "saveEdition": "Save edition",
      "discard": "Discard my edits and reload",
      "approvalNotice": "Approval saves this exact CV privately. Your current public version stays as it is.",
      "approve": "Approve this version",
      "makePublicMain": "Use as my public Web CV",
      "showSelectedPreview": "Review the selected CV wording",
      "hideSelectedPreview": "Hide CV preview",
      "sharedEdition": "Shared saved edition: {{locale}}",
      "checkEdition": "Check this saved edition with CV Health",
      "dateFormat": "Use a valid date: YYYY, YYYY-MM or YYYY-MM-DD. Use Present for a current role. Your draft is still here.",
      "healthSavedNotice": "These checks describe this saved edition. Edit the draft to make changes, then check the new version.",
      "healthUnavailable": "This edition could not be checked. Your saved wording is unchanged. Try again.",
      "saveSharedEdition": "Share this saved edition with the app",
      "publicationNotice": "Publishing shares the last approved version using your current visibility settings. Set the CV to Public first.",
      "publish": "Publish approved version",
      "unpublish": "Unpublish this version",
      "ownerApproves": "The owner approves releases and controls publication.",
      "translations": "Language editions",
      "translationNotice": "A translation is a proposal. Review it here before accepting; your current wording stays until you accept.",
      "generate": "Propose {{language}} edition",
      "proposalAt": "Review proposal from {{date}}",
      "staleProposal": "This proposal was made before the latest edit. Reject it or generate a fresh proposal.",
      "uncertaintyAcknowledgment": "I reviewed the {{count}} uncertain translation details against the source.",
      "acceptProposal": "Accept proposal",
      "rejectProposal": "Reject proposal",
      "history": "Show saved versions",
      "hideHistory": "Hide saved versions",
      "historyVersion": "Version {{version}} · {{date}}",
      "releaseAt": "Saved release · {{date}}",
      "noHistory": "No saved versions yet.",
      tabs: { review: 'Review', languages: 'Languages', history: 'History' },
      editionSwitch: 'Edition',
      statusLabel: 'Release status',
      status: {
        draftApproved: 'Draft approved', draftChanged: 'Draft has unapproved changes', draftNotApproved: 'Draft not approved yet',
        live: 'Live: version approved {{date}}', liveUndated: 'A version is live', notLive: 'Nothing live yet',
        liveBadge: 'Live', notLiveBadge: 'Not live',
        liveIsOlder: 'People with your link still see the version approved {{date}} until you publish this one.',
      },
      publishVersion: 'Publish version approved {{date}}',
      restoreDraftVersion: 'Restore draft version {{version}} as a new draft',
      showCompleteVersions: 'Show complete versions', hideCompleteVersions: 'Hide complete versions',
      noChanges: 'These two versions have the same wording.',
      editBar: { editing: 'Editing this edition', unsaved: 'Unsaved changes', hint: 'Save or discard your changes to switch tabs.' },
      currentDraft: 'Current draft',
      versionMeta: 'Version {{version}}',
      showApprovedWording: 'Show approved wording',
      hideApprovedWording: 'Hide approved wording',
      pendingProposals: 'Proposals to review',
      historyGroups: { drafts: 'Draft versions', editions: 'Edition versions', releases: 'Approved releases' },
      changes: 'What changed',
      library: {
        review: 'Review',
        needsReview: 'Needs review',
        languages: 'Languages',
        languageEdition: 'Language edition',
        recent: 'Recent changes',
        allVersions: 'All saved versions',
        openFullReview: 'Open full review',
        factsChangedHint: 'Compare them before you approve or publish.',
        badge: { published: 'Published', approved: 'Approved', draft: 'Draft', needsReview: 'Needs review' },
      },
      "fields": {
        "photoIncluded": "Profile photo included",
        "name": "Name",
        "title": "Role or title",
        "summary": "Summary",
        "bio": "About",
        "location": "Location",
        "contactEmail": "Email",
        "company": "Company",
        "employmentType": "Employment type",
        "startDate": "Start date",
        "endDate": "End date",
        "overview": "Overview",
        "school": "School",
        "degree": "Degree",
        "fieldOfStudy": "Field of study",
        "description": "Description",
        "issuer": "Issuer",
        "issueDate": "Issue date",
        "expirationDate": "Expiration date",
        "credentialUrl": "Credential link",
        "desc": "Description",
        "link": "Link",
        "bullets": "Achievement",
        "category": "Category",
        "skill": "Skill",
        "language": "Language"
      },
      "sections": {
        "experiences": "Experience",
        "educations": "Education",
        "certifications": "Certification",
        "highlights": "Highlight",
        "projects": "Project",
        "skillGroups": "Skills"
      },
      "followApproved": "Follow versions I approve",
      "exactVersion": "Send this exact version",
      "chooseApproved": "Choose an approved version",
      "approvedAt": "Approved {{date}}",
      "needsApproval": "Approve a version before creating this link."
    },
    importEvidence: {
      "title": "Import evidence",
      "privateNotice": "Only you can view this source and its captured import results. Compare them before correcting missing or uncertain details. These are captured imports; later manual edits are not included.",
      "details": "Review source and result",
      "hide": "Hide details",
      "current": "Current import",
      "previous": "Previous import",
      "captured": "Captured {{date}}",
      "missing": "Sections the source declared but the import did not capture: {{sections}}.",
      "cleared": "This import will clear existing sections: {{sections}}.",
      "fallback": "This import used fallback extraction. Review the source and parsed result carefully.",
      "datePrecision": "Year-only and month-only dates keep that precision. Missing or uncertain dates do not establish a day or month. An ongoing role is shown only when explicitly stated.",
      "dateCounts": "Captured dates: {{year}} year-only, {{month}} month-only, {{unknown}} uncertain.",
      "originalUnavailable": "The original uploaded file is not available here.",
      "sourceUnavailable": "The original source text was not captured for this document.",
      "qualityUnavailable": "Parse quality was not captured for this document.",
      "truncated": "The retained source text may be incomplete because it reached the text limit.",
      "source": "Captured source text",
      "extracted": "Captured extraction before enrichment",
      "parsed": "Captured import result",
      "loadFailed": "Import evidence could not be loaded. Your CV is unchanged.",
      "reviewTitle": "Review incomplete CV import",
      "reviewBody": "Some source details were not captured or existing sections will be cleared. Review the following before saving. Cancelling keeps your draft and leaves your CV unchanged.",
      "confirm": "Save this reviewed import",
      "sourceChanged": "The import source or CV changed. Your draft is kept. Parse the source again and review it before saving.",
      "resumeDraft": "Resume your saved import draft",
      "resumeReview": "Review import again",
      "sections": {
        "experience": "Work experience",
        "experiences": "Work experience",
        "education": "Education",
        "educations": "Education",
        "certifications": "Certifications",
        "projects": "Projects",
        "skills": "Skills",
        "skillGroups": "Skills",
        "languages": "Languages",
        "highlights": "Highlights",
        "careerHighlights": "Highlights",
        "summary": "Summary",
        "header": "Contact details"
      }
    },
    title: "My CVs",
    subtitle: "Create and manage your CV profiles",
    editor: "CV Editor",
    templates: "Templates",
    preview: "Preview",
    viewAnalytics: "View analytics",
    hub: {
      title: "My Tabbio",
      cvsTitle: "CVs",
      copyLink: "Copy link",
      linkCopied: "Link copied",
      share: "Share",
      verifiedLabel: "UAE PASS verified",
      updated: "Updated {{time}}",
      updatedToday: "Updated today",
      createCv: "Create CV",
      accountLabel: "Account",
      openCv: "Open CV",
    },
    list: {
      title: "CVs",
      searchPlaceholder: "Search",
      clearSearch: "Clear search",
      mainBadge: "Main",
      masterTitle: "Main CV",
      profileTitle: "Profile CV",
      masterDescription: "Built from your Tabbio profile",
      relativeTime: {
        now: "just now",
        minutes: "{{count}}m ago",
        hours: "{{count}}h ago",
        days: "{{count}}d ago",
        weeks: "{{count}}w ago",
        months: "{{count}}mo ago",
        years: "{{count}}y ago",
      },
      forOthers: "For others",
      sharedWithMe: "Shared with me",
      sentByMe: "Sent by me",
      emptyTitle: "No CVs yet",
      emptySubtitle: "Create your first CV to get started.",
      noResults: "No CVs match your search.",
      openMenu: "More options",
      createAria: "Create CV",
    },
    menu: {
      open: "Open",
      rename: "Rename",
      makeMain: "Make This My Main CV",
      makeNew: "Duplicate CV",
      sharePublicly: "Share Publicly",
      versionHistory: "Version History",
      archive: "Delete permanently",
      comingSoon: "Coming soon",
      copyTitle: "{{title}} Copy",
      renameTitle: "Rename CV",
      renamePlaceholder: "CV name",
      save: "Save",
      cancel: "Cancel",
      mainSaved: "Main CV updated",
      mainFailed: "Could not update main CV",
      renameFailed: "Could not rename CV",
      duplicateSaved: "CV duplicated",
      duplicateFailed: "Could not duplicate CV",
      archiveSaved: "CV permanently deleted",
      archiveFailed: "Could not delete CV",
      archiveConfirmTitle: "Permanently delete CV?",
      archiveConfirmMessage:
        "Permanently delete “{{title}}”? This cannot be undone.",
      versionHistoryTitle: "Version History",
      versionHistoryEmpty: "No activity yet.",
    },
    create: {
      title: "Create CV",
      forMe: "For me",
      forMeSubtitle: "Generate or upload your own CV",
      forOthers: "For someone else",
      forOthersSubtitle: "Build a CV they can claim",
      stepOf: "Step {{current}} of {{total}}",
      steps: {
        source: "Start from",
        tailor: "Tailor it",
      },
      namePlaceholder: "e.g., Backend Engineer - Google",
      nameHint: "Optional. We will name it for you if you leave this blank.",
      nameToggle: "Name this CV",
      copyTitle: "{{name}} (copy)",
      defaultTitle: {
        blank: "Untitled CV",
        profile: "My CV",
      },
      generating: "Writing your CV. This takes a few seconds.",
      source: {
        heading: "What should we start from?",
        subheading:
          "Pick where this CV's content comes from. You can tailor it in the next step.",
        label: "Start from",
        existing: "An existing CV",
        existingHint: "Pick one of your CVs to build on",
        existingEmptyHint: "You do not have a CV yet",
        untitledCv: "Untitled CV",
        pickerTitle: "Choose a CV",
        defaultCvTag: "Default CV",
        pickerSubtitle: "The new CV starts from the one you pick here.",
        pickerHint: "Opens the list of your CVs",
        upload: "Upload a resume",
        uploadHint: "PDF, DOC, DOCX, image, or pasted text",
        uploadReady: "Resume read. Ready to continue.",
        uploadReplace: "Replace",
        blank: "Blank CV",
        blankHint: "Start with an empty CV and fill it in yourself",
      },
      tailor: {
        heading: "Tailor it?",
        subheading: "Apply a Custom CV or target a job description.",
        label: "Tailor",
        skill: "Custom CV",
        skillHint: "Ready-made rewrites for a market, level, or role",
        skillNeedsJd: "This custom CV also needs the job description",
        skillPickerTitle: "Choose a Custom CV",
        skillPickerSubtitle:
          "Built by career experts and the community. Each one changes how your CV is written, section by section.",
        skillInfo:
          "Custom CVs are ready-made rewrites for a market, career level, or role.",
        skillFilters: "Filter custom CVs",
        skillMenu: "Custom CV options",
        viewSkillDetails: "View details",
        shareSkill: "Share",
        reportSkill: "Report",
        reportSkillConfirm: "Report this custom CV for review?",
        skillPickerOpen: "Choose a Custom CV",
        skillPickerChange: "Tap to choose a different custom CV",
        skillSearchPlaceholder: "Search custom CVs",
        skillSearchEmpty: "No custom CVs match that search.",
        skillsEmpty: "No custom CVs fit this starting point yet.",
        skillsError: "Could not load custom CVs. Try again in a moment.",
        jd: "Target a job description",
        jdHint: "Paste the posting and we tailor the CV to it",
        jdPlaceholder:
          "Paste a job description, or describe the role you want to target.",
        jdAttach: "Attach the job post (PDF or photo)",
        jdAttachClear: "Remove attachment",
        jdAttachFailedTitle: "Couldn't read that file",
        jdAttachTooLarge:
          "That file is over 10MB. Attach a smaller file or paste the text.",
        jdAttachUnreadable:
          "We couldn't read text from this file. Try a PDF, Word document, or a clear photo of the job post.",
      },
      recap: {
        existing: "Starting from your CV: {{name}}",
        upload: "Starting from the resume you uploaded",
        profile: "Starting from your Tabbio profile",
      },
      someoneElse: {
        toggle: "This CV is for someone else",
      },
      actions: {
        back: "Back",
        continue: "Continue",
        create: "Create CV",
        createTailored: "Create tailored CV",
      },
      success: {
        skillTitle: "Tailored CV ready",
        skillBody: "{{skill}} was applied. Opening your new CV.",
      },
      errors: {
        sourceRequired: "Pick what to start from first",
        sourceCvRequired: "Pick which CV to start from",
        tailorRequired: "Choose a CV skill or add a job description",
        resumeRequired: "Upload or paste a resume first",
        skillRequired: "Pick a CV skill first",
        jobDescriptionRequired:
          "Add at least a short target role or job description.",
        skillInputsRequired: "Answer the skill's questions first",
        sourceCvEmpty:
          "This CV has no experience, education or highlights yet, so the skill has nothing to work from.",
        skillNotIncluded: "This skill is not included in your plan.",
        network: "Could not reach the server. Check your connection and try again.",
        tooManyRequests: "Too many attempts. Wait a moment and try again.",
        failedTitle: "Could not create CV",
        failedBody: "Something went wrong. Try again.",
      },
    },
    handoff: {
      sendTitle: "Send CV",
      sendSubtitle:
        "Send this CV as a copy or transfer it when the recipient claims it.",
      recipientName: "Recipient name",
      recipientNamePlaceholder: "e.g., Amina Hassan",
      recipientEmail: "Recipient email",
      recipientEmailPlaceholder: "name@example.com",
      recipientPending: "Recipient not set",
      modeLabel: "Delivery",
      copy: "Send a copy",
      copyDescription:
        "They receive their own CV and you keep editing your original.",
      transfer: "Transfer when claimed",
      transferDescription:
        "They receive an owned copy and your version stays as a backup.",
      sendInvite: "Send invite",
      resendInvite: "Resend invite",
      sendShort: "Send",
      sendSuccess: "CV invite sent",
      sendFailed: "Could not send CV invite",
      signInRequired: "Sign in to claim this CV",
      openingInvite: "Opening your CV invite",
      inviteTitle: "Shared with you",
      inviteSentBy: "{{name}} sent you this. Nothing changes until you choose.",
      inviteTransferNote:
        "{{name}} is handing it over. Their version stays as a backup on their side.",
      chooseUpdate: "Update my main CV",
      chooseUpdateDescription:
        "This becomes your main CV. You can review it first.",
      chooseCopy: "Keep it as a separate copy",
      chooseCopyDescription:
        "It joins your other CVs. Your main one stays as it is.",
      confirmUpdateTitle: "Replace your main CV?",
      confirmUpdateBody:
        "Your main CV content (header, summary, experience, education, skills and more) will be replaced with the CV you were sent. Your existing CVs and copies are not deleted.",
      confirmUpdateCta: "Yes, update my CV",
      confirmUpdateCancel: "Go back",
      claimingTitle: "Claiming CV",
      claimingBody: "We are creating your own copy.",
      claimUpdatingBody: "We are updating your CV with the content you were sent.",
      claimFailedTitle: "Could not claim this CV",
      claimFailedBody:
        "This invite may be expired, cancelled, or meant for another email.",
      claimOwnerTitle: "This is your own CV",
      claimOwnerBody:
        "You created this invite, so there's nothing to claim. Ask the person you sent it to open the link from their own account.",
      claimWrongEmailTitle: "Signed in with a different email",
      claimWrongEmailBody:
        "This invite was sent to {{email}}. Sign out and sign back in with that email to claim the CV.",
      claimWrongEmailBodyGeneric:
        "This invite was sent to a different email. Sign in with the email that received the invite to claim the CV.",
      claimExpiredTitle: "This invite has expired",
      claimExpiredBody:
        "Ask the sender to resend the CV invite, then open the new link.",
      claimRetryCta: "Try again",
      claimExitCta: "Go to my Tabbio",
      // The claim committed but the profile write behind "update" did not: the
      // copy is theirs, the invite is spent, and there is nothing to retry.
      claimProfileNotUpdatedTitle: "Your CV is in your account",
      claimProfileNotUpdatedBody:
        "We could not update your profile with it. The CV you were sent is saved and ready to open.",
      claimOpenCvCta: "Open the CV you were sent",
      claimSkippedRolesTitle: "Some roles stayed in the CV only",
      claimSkippedRolesBody:
        "A few roles did not state a start date, so they are in the CV you were sent but not in your profile.",
      status: {
        draft: "Draft for someone",
        pendingCopy: "Pending copy",
        pendingTransfer: "Pending transfer",
        claimedCopy: "Claimed copy",
        claimedTransfer: "Transferred backup",
        cancelled: "Cancelled",
        expired: "Expired",
      },
    },
    share: {
      title: "Share your Tabbio",
      done: "Done",
      tabPublic: "Public",
      tabDirect: "Direct",
      tabDownload: "Download",
      publicLink: "Public link",
      contactHidden: "Contact info hidden",
      contactHiddenSub: "Viewers can message you through Tabbio",
      cvHidden: "Your CV is hidden",
      directShare: "Direct share",
      directShareDesc: "Private link with full contact info visible",
      resetLink: "Reset link",
      linkReset: "Link reset",
      scanToView: "Scan to view CV",
      downloadQr: "Download QR",
      downloadVcard: "Download vCard",
      saveContact: "Save contact to phone",
      printShare: "Print & Share",
      printShareDesc: "Ready to send to employers",
      editInWord: "Edit in Word",
      editInWordDesc: "Customize in Microsoft Word",
      postSocial: "Post on Social",
      postSocialDesc: "Share as an image",
      importAts: "Import to ATS",
      importAtsDesc: "For hiring platforms",
      upgradePro: "Upgrade to Pro →",
      copy: "Copy",
      whatsapp: "WhatsApp",
      linkedin: "LinkedIn",
      email: "Email",
      privacy: "By sharing you agree to Tabbio's",
      privacyPolicy: "Privacy Policy",
      terms: "Terms",
      linkCopied: "Copied!",
      nativeShareTitle: "Check out my CV",
      downloadPdf: "Download PDF",
      downloadPdfDesc: "Styled CV with your template & colors",
      downloadWord: "Download Word",
      downloadWordDesc: "Editable .docx document",
      downloadTxt: "Plain Text",
      downloadTxtDesc: "ATS-friendly text format",
      downloadMd: "Markdown",
      downloadMdDesc: "Structured markdown format",
      plusRequired: "Plus",
      downloadFailed: "Download failed. Please try again.",
      linkCreateFailed: "Could not create private link",
      linkUnavailable: "Set your Tabbio link to share",
      download: "Download",
      downloadOptions: "Download Options",
      copied: "Copied",
      qr: "QR code",
      qrHint: "Anyone who scans this opens your CV.",
      qrSave: "Save QR",
      qrFailed: "Could not save the QR code.",
      downloadFormat: "Download {{format}}",
      hideLogo: "Hide Tabbio logo",
      hideLogoHint: "Remove the Tabbio mark from your card.",
      customizeCard: "Customize card",
      customizeCardHint: "Background, title, photo",
      advanced: "Advanced options",
      advancedHint: "Visibility, link, activity",
      people: "People",
      peopleHint: "Invite people to view or edit this CV.",
      upgrade: "Upgrade",
      shareVia: "Share",
      // ─── Redesigned share screen (Figma 2958:8789) ───
      includeContact: "Include phone & email",
      openCv: "Open CV",
      // The share card's default call to action (the "View CV" preset; it opens the CV).
      cardCta: "View CV",
      downloadCv: "Download CV",
      privacyControls: "Privacy controls",
      // "Share with contact info": the one standing private link, always with
      // phone & email. Created on demand, revocable, replaceable.
      contact: {
        title: "Share with contact info",
        intro: "This link shows your regular CV, phone number and email.",
        forwardHint: "Anyone with it can forward it. You can revoke it anytime.",
        create: "Create link",
        createNew: "Create a new link",
        readyIntro: "Your CV, phone number and email are included.",
        linkLabel: "Contact link",
        readyHint: "Anyone with the link can forward it.",
        revoke: "Revoke link",
        revokedTitle: "Link revoked",
        revokedBody: "The old link no longer opens your CV.",
        linkReady: "CV link ready",
        linkRevoked: "Link revoked",
        revokeFailed: "Could not revoke this link",
      },
      privateLink: "Private link you can revoke anytime",
      privateLinkStale: "Still shows the previous phone & email setting",
      linkUpdateFailed: "Could not update this link",
      preparingPrivateLink: "Preparing private link...",
      retry: "Retry",
      addToLinkedin: "Add to LinkedIn",
      access: "Access",
      downloadAs: "Download As",
      free: "Free",
      qrTitle: "My CV QR Code",
      qrSubtitle: "Scan to open my CV.",
      // Access sheet (Figma 2958:7916)
      accessTitle: "You Decide Who Sees You",
      accessSubtitle: "Your privacy, your call, change it anytime",
      accessPublic: "Public",
      accessPublicHint: "Contacts invisible to employers only",
      accessEmployers: "Employers Only",
      accessEmployersHint: "Your CV stays hidden from the public",
      accessPrivate: "Fully Private",
      accessPrivateHint: "Nothing shared",
      owner: "Owner",
      you: "(You)",
      inviteByEmail: "Invite by email",
      invite: "Invite",
      inviteHint:
        "Invited people can edit your CV. You stay the owner and can remove access anytime.",
      // LinkedIn sheet (Figma 2958:8635)
      linkedinTitle: "Share To LinkedIn",
      linkedinSubtitle: "Add your CV to your LinkedIn profile features",
      // The public-CV gate covers every share platform, not just LinkedIn, so
      // the message names whichever one the user actually picked.
      platformPublicRequired:
        "{{platform}} previews need a public CV. Choose Public access, then copy your short Tabbio link.",
      // Same gate reached from the lock notice beside the link, where no
      // platform is involved.
      linkPublicRequired:
        "Your Tabbio link only works while your CV is public. Choose Public access to share it.",
      goToLinkedin: "Go To My LinkedIn",
      // Sits under the public URL and opens Access when tapped.
      profilePrivateNotice:
        "Your Tabbio link is unavailable while your profile is private. Tap to make it public.",
    },
    advanced: {
      title: "Advanced options",
    },
    customizeCard: {
      // The CV layout customizer (CustomizeBottomSheet) still carries this title.
      title: "Customize Preview",
      // ─── "Edit share preview": the preview-first share card editor ───
      editorTitle: "Edit share preview",
      trialNote: "Try any style. Premium is needed to save paid options.",
      premium: "Premium",
      theme: "Card theme",
      themes: {
        white: "White",
        black: "Black",
        tabbio: "Tabbio",
        custom: "Custom",
        aurora: "Aurora",
        dusk: "Dusk",
        uae: "UAE",
        saudi: "Saudi Arabia",
        qatar: "Qatar",
        kuwait: "Kuwait",
        bahrain: "Bahrain",
        oman: "Oman",
      },
      customColor: "Custom color",
      hexColor: "Hex color",
      background: "Background",
      patterns: {
        none: "Plain",
        signature: "Tabbio",
        cv: "CV",
        orbit: "Orbit",
        arch: "Briefcase",
        wave: "Wave",
      },
      usePhoto: "Use profile photo",
      name: "Name",
      headline: "Headline",
      buttonText: "Button text",
      buttonPresets: "Suggested button text",
      cardLink: "Card link",
      clearLink: "Clear",
      resetLink: "Reset to default",
      linkNote: "Card artwork only. Copy and Share use your Tabbio profile link.",
      hideLogo: "Hide Tabbio logo",
      addBackgroundImage: "Add background image",
      upgradeBadge: "UPGRADE",
      done: "Done",
      removeImage: "Remove image",
      uploading: "Uploading…",
      uploadFailed: "Could not upload the image.",
      savePreview: "Save preview",
      upgradeToSave: "Upgrade to save",
      restoreFree: "Restore free options",
      saved: "Preview saved",
    },
    sharePanel: {
      copy: "Copy",
      copied: "Copied",
      tabs: {
        link: "Link",
        people: "People",
        download: "Download",
        activity: "Activity",
      },
      language: {
        title: "Language",
        subtitle: "Create and share a language-specific version.",
        original: "Original",
        generateArabic: "Generate Arabic",
        generatingArabic: "Generating Arabic...",
        generatingArabicShort: "Generating...",
      },
      visibility: {
        email: "Email",
        phone: "Phone",
        location: "Location",
        links: "Social links",
        photo: "Photo",
      },
      link: {
        title: "Share controls",
        defaultLabel: "CV link",
        languageLabel: "Language-specific CV link",
        allowDownload: "Allow downloads from this link",
        create: "Create direct link",
        createNew: "Create new direct link",
        creating: "Creating link...",
        publicWebCv: "Public CV",
        saveVisibility: "Save visibility",
      },
      people: {
        title: "People with access",
        invite: "Invite editor",
        inviteShort: "Invite",
        inviting: "Inviting...",
        emailPlaceholder: "name@example.com",
        accessLink: "CV access link",
        accessLinkEmpty: "Invite someone to create an access link.",
        inviteLinkCreated: "Invite link created and emailed.",
        grantedDirect:
          "{{email}} can now open this CV from their Tabbio workspace.",
        invalidEmail: "Enter a valid email address.",
        selfInvite: "You already own this CV.",
        alreadyPending: "{{email}} already has a pending invite.",
        alreadyHasAccess: "{{email}} already has access.",
        inviteFailed: "Could not send this invite. Please try again.",
        loadFailed: "Could not load people with access.",
        invitedUser: "Invited user",
        revoke: "Revoke",
        revoking: "Revoking...",
        revoked: "Access revoked.",
        status: {
          pending: "Invite pending",
          active: "Active access",
          revoked: "Revoked",
        },
        empty: "No one else has access yet.",
      },
      download: {
        title: "Download options",
        download: "Download",
        downloading: "Downloading...",
      },
      activity: {
        title: "{{title}} activity",
        empty: "No activity yet.",
      },
    },
    publicShare: {
      loading: "Loading CV...",
      subtitle: "Shared CV",
      notFoundTitle: "This CV link is unavailable",
      notFoundBody: "The link may have expired or been turned off.",
      downloadFailed: "Download failed. Please try again.",
    },
    accessInvite: {
      signInRequired: "Sign in to accept this CV invite",
      acceptingTitle: "Accepting invite",
      acceptingBody: "Opening the shared CV workspace.",
      failedTitle: "This invite is unavailable",
      failedBody: "The invite may have expired or already been used.",
    },
    // Opening a shared CV the user already has access to (no invite to
    // redeem): see app/cv-grant/[grantId].
    grantHandoff: {
      opening: "Opening shared CV",
      signInRequired: "Sign in to open this shared CV",
    },
    sharedWithMe: {
      title: "Shared with me",
      pageTitle: "Shared CVs",
      pageSubtitle: "CVs you can review or edit for other people.",
      loading: "Loading",
      count: "{{count}} CVs",
      owner: "From {{owner}}",
      empty: "No shared CVs yet.",
      emptyBody:
        "Ask a teammate, manager, or recruiter to share a CV with you: once they grant access, it shows up here for you to review or edit.",
    },
    accessError: {
      sharedTitle: "This shared CV is not available",
      sharedBody:
        "The owner may have removed your access, or the link is no longer valid. Ask them to share it again.",
      ownTitle: "We could not load your CV",
      ownBody: "Check your connection and try again.",
      retry: "Try again",
      openMine: "Open my CV",
    },
    edit: {
      projectTitle: "Project title",
      projectDescription: "Description",
      projectTechnologies: "Technologies (one per line)",
      projectLink: "Project URL",
      addProject: "Add project",
      projectTitleRequired: "Enter a project title.",
      projectLinkInvalid: "Enter a complete http or https URL.",
      noProjects: "No projects added yet.",

      sections: "Edit CV",
      headerContact: "Header & Contact",
      summary: "Summary",
      highlights: "Career Highlights",
      skills: "Skills",
      experience: "Experience",
      education: "Education",
      projects: "Projects",
      certifications: "Certifications",
      languages: "Languages",
      jobPreferences: "Job Preferences",
      jobPreferencesLoadFailed: "We could not load your job preferences.",
      customize: "Customize",
      customizeDone: "Done",
      customizeCancel: "Cancel",
      personalInfo: "Personal Info",
      career: "Career",
      skillsAndLanguages: "Skills & Languages",
      preferences: "Preferences",
      identity: "Identity",
      name: "Name on CV",
      usernameReadOnlyShared:
        "The owner username cannot be changed from a shared CV.",
      usernameReadOnlyTailored:
        "Username belongs to your main Tabbio profile and is not changed per tailored CV.",
      showTabbioLink: "Show Tabbio link",
      showTabbioLinkHint:
        "Prints your Tabbio address in the CV header. Turn it off to keep the CV unbranded.",
      email: "Email",
      phone: "Phone",
      location: "Location",
      linkedinUrl: "LinkedIn URL",
      websiteUrl: "Website URL",
      profileImage: "Profile Image",
      profileImageHint: "Used across your CV and public profile.",
      uploadPhoto: "Upload photo",
      changePhoto: "Change photo",
      uploadingPhoto: "Uploading...",
      photoUploadFailed: "Could not upload your photo",
      headline: "example: HR & Technology Expert",
      summaryText:
        "example: A passionate HR professional with 7+ years of experience in talent acquisition and employee engagement.",
      highlightTitle: "Title",
      highlightDesc: "Impact / Description",
      addHighlight: "Add Highlight",
      highlightIntro: "Key achievements on your CV",
      suggestHighlight: "Suggest highlight",
      suggestedHighlight: "Suggested highlight",
      saveSuggestion: "Save suggestion",
      tryAnotherSuggestion: "Try another",
      dismissHighlightSuggestion: "Dismiss suggestion",
      noHighlights: "No highlights yet",
      highlightNumber: "Highlight {{number}}",
      tapToEdit: "Tap to edit",
      generateHighlightFailed: "Could not suggest a highlight",
      noNewHighlightSuggestion: "No new suggestion was available. Try again.",
      dragToReorder: "Press and hold a handle, then drag to reorder",
      reorderItem: "Reorder {{item}}",
      moveItemUp: "Move {{item}} up",
      moveItemDown: "Move {{item}} down",
      categoryName: "Category Name",
      addSkill: "Add skill...",
      addCategory: "Add Category",
      role: "Role / Job Title",
      company: "Company",
      locationType: "Location Type",
      locationTypeRemote: "Remote",
      locationTypeOnSite: "On-site",
      locationTypeHybrid: "Hybrid",
      employmentType: "Employment Type",
      period: "Period",
      overview: "Overview",
      keyAchievements: "KEY ACHIEVEMENTS",
      addBullet: "Add achievement...",
      addAchievementHint: "Type an achievement and press Add or Enter",
      addPosition: "Add Position",
      startDate: "Start Date",
      endDate: "End Date",
      currentRole: "I currently work here",
      degree: "Degree",
      school: "School / University",
      year: "Year",
      description: "Description",
      addEducation: "Add Education",
      noEducation: "No education added yet",
      certName: "Certification Name",
      issuer: "Issuer",
      date: "Date",
      credentialUrl: "Credential URL",
      credentialUrlHint:
        "Link to verify this credential (e.g. Credly badge URL)",
      addCertification: "Add Certification",
      language: "Language",
      proficiency: "Proficiency",
      addLanguage: "Add Language",
      editLanguage: "Edit Language",
      proficiencyRequired: "Proficiency is required",
      addLanguageHint: "Type a language and press Add or Enter",
      searchLanguages: "Search Languages",
      searchToAddLanguage: "Search for a language to add",
      noExperience: "No experience added yet",
      selectProficiency: "Choose level",
      done: "Done",
      proficiencyLevels: {
        elementary: "Basic",
        limited: "Intermediate",
        professional: "Professional",
        fullProfessional: "Fluent",
        native: "Native",
      },
      addSkillHint: "Type a skill and press Add or Enter",
      add: "Add",
      nameRequired: "Name is required",
      issuerRequired: "Issuer is required",
      dateRequired: "Date is required",
      invalidDate: "Invalid date",
      dateInFuture: "Date cannot be in the future",
      roleRequired: "Role is required",
      roleTooShort: "Enter a complete job title",
      companyRequired: "Company is required",
      startDateRequiredForCurrent:
        "Add a start date before marking this as your current role",
      startAfterEnd: "End date must be after start date",
      invalidEmail: "Enter a valid email address",
      invalidUrl: "Enter a valid URL",
      tooLong: "Too long (max {{max}} characters)",
      invalidChars: "Please remove special characters",
      limitReached: "Maximum length reached",
      degreeRequired: "Degree is required",
      schoolRequired: "School is required",
      invalidYear: "Enter a valid year",
      skillRequired: "Skill is required",
      categoryRequired: "Category name is required",
      languageRequired: "Language is required",
      unsupportedLanguage: "Select a supported language",
      duplicateLanguage: "Language already added",
      duplicateSkill: "Skill already added",
      highlightTitleRequired: "Title is required",
      highlightDescRequired: "Description is required",
      headlineRequired: "Professional title is required",
      summaryRequired: "Summary is required",
      openToWorkToggle: "Open to Work",
      openToWorkDesc: "Let recruiters know you're available",
      jobTitles: "Suggested Job Titles",
      searchJobTitle: "Search role / job title...",
      addCustomRole: 'Add "{{query}}"',
      noMatchingRoles: "No matching roles: press add to use it anyway",
      suggestedRoles: "Suggested roles",
      suggestedSkills: "Suggested skills",
      suggestionsHeading: "Suggestions",
      acceptAll: "Accept all",
      dismissAll: "Dismiss all",
      taxonomySearch: "Search roles or skills",
      addCanonicalRole: "Add role",
      addCanonicalSkill: "Add skill",
      noSkillsYet: "No skills yet",
      // Screen-reader labels for the skills chip editor: a chip's tap target
      // and its dismiss/remove target need distinct names.
      aiSuggestSkills: "Suggest skills",
      addSkillNamed: "Add {{skill}}",
      dismissSuggestion: "Dismiss {{skill}}",
      removeSkill: "Remove {{skill}}",
      removeCategory: "Remove category",
      locationTypes: "Location Types",
      preferredLocations: "Preferred Locations",
      employmentTypes: "Employment Types",
      relocation: "Relocation & Notice",
      whereTo: "Where To?",
      noticePeriod: "Notice Period",
      morePreferences: "More preferences",
      morePreferencesHint: "Salary, seniority, exclusions, relocation and notice period",
      morePreferencesSet: "{{n}} set",
      save: "Save",
      saving: "Saving...",
      saved: "Saved",
      saveFailed: "Save failed",
      remove: "Remove",
      professionalTitle: "Professional title",
      summaryLabel: "Summary",
      customizeColor: "Color",
      customizeLayout: "Layout",
      customizePhoto: "Photo",
      customizePhotoShow: "Show photo",
      customizePhotoHide: "Hide photo",
      customizeFitOnePage: "Keep PDF to one page",
      customizeFitOnePageHint:
        "Uses a compact layout only when the exported PDF needs it",
      customizeFitOnePageEnabledHint:
        "One-page mode is on. CVs that already fit will look unchanged",
      completePosition:
        "Some details are missing: complete the highlighted position.",
      deleteItemTitle: "Delete {{object}}?",
      deleteItemMessage:
        "Are you sure you want to delete {{object}} from your CV?",
      deleteTargets: {
        project: "this project",
        position: "this position",
        achievement: "this achievement",
        education: "this education entry",
        certification: "this certification",
        highlight: "this highlight",
        language: "this language",
        skillGroup: "this skill group",
        skill: "this skill",
        link: "this link",
        jobTitle: "this job title",
        searchArea: "this search area",
      },
      delete: "Delete",
      cancel: "Cancel",
      native: "Native",
      fluent: "Fluent",
      advanced: "Advanced",
      intermediate: "Intermediate",
      basic: "Basic",
      remote: "Remote",
      onSite: "On-site",
      hybrid: "Hybrid",
      items: "{{count}} items",
      positions: "{{count}} positions",
      entries: "{{count}} entries",
      groups: "{{count}} groups",
      filled: "Filled",
      empty: "Empty",
      blankPreviewTitle: "Your CV is ready to build",
      blankPreviewBody:
        "Add experience, education, skills, and more. You can reorder or hide sections at any time.",
      addSections: "Add sections",
      blankPreviewActionHint: "Opens the CV section editor",
      blankEditorTitle: "Choose your first section",
      blankEditorBody:
        "Start with experience, education, or skills. You can edit, reorder, or hide sections later.",
      addDetails: "Add details",
      sectionVisible: "Shown",
      sectionHidden: "Hidden",
      showSection: "Show section",
      hideSection: "Hide section",
      manageSections: "Manage",
      doneManaging: "Done",
      sectionOrder: "Section order",
      shownSections: "Shown sections",
      hiddenSections: "Hidden sections",
      moveSectionUp: "Move section up",
      moveSectionDown: "Move section down",
      describeToAI: "Describe to AI",
      describeToAISend: "Generate",
      suggestAI: "Suggest with AI",
      resuggestAI: "Re-suggest with AI",
      spark: {
        enhance: "Enhance",
        enhancing: "Enhancing…",
        scopeMenu: "Choose scope",
        scopeSection: "This section",
        scopeFullCv: "Full CV",
        applySkill: "Apply a skill",
        applySkillComingSoon: "Coming soon",
        suggestion: "AI suggestion",
        useThis: "Use this",
        keepOriginal: "Keep original",
      },
    },
    previewScreen: {
      title: "CV Preview",
      profileSummary: "Profile Summary",
      careerHighlights: "Career Highlights",
      keySkills: "Key Skills",
      professionalExperience: "Professional Experience",
      education: "Education",
      projects: "Projects",
      certifications: "Licenses & Certifications",
      verifyCredential: "Verify",
      languages: "Languages",
      present: "Present",
      openToWork: "Open to Work",
      editCv: "Edit CV",
      tailored: "Tailored",
      customize: "Customize",
      copyLink: "Copy Link",
      copied: "Copied!",
      shareWebCv: "Share CV",
      fullTime: "Full-time",
      partTime: "Part-time",
      contract: "Contract",
      freelance: "Freelance",
      loadError: "Could not load your CV",
      retry: "Retry",
      noData: "No CV data available yet",
      noDataSubtitle: "Complete your profile to see your CV preview",
    },
    bottomBar: {
      cvs: "CVs",
      edit: "Edit",
      theme: "Theme",
      analytics: "Views",
      enhance: "Enhance",
      enhanceDefaultPrompt:
        "Improve the CV currently open in Tabbio directly. Preserve every fact. Tighten the summary and experience bullets, use clear action-and-result wording, remove repetition, and keep the strongest relevant skills. Do not invent details or suggest a CV skill unless I ask.",
      enhanceTargetMain: "Target CV: my profile-backed main CV.",
      enhanceTargetTailored: "Target CV ID: {{id}}.",
      enhanceSend: "Send CV change request",
    },
    enhance: {
      confirmTitle: "Enhance this CV?",
      confirmMessage:
        "AI will rewrite the summary, headline, skills, and experience bullets in place for clarity and impact. Every role is kept, but the current wording is replaced. This can take up to half a minute.",
      confirmAction: "Enhance",
      successTitle: "CV enhanced",
      successBody: "The summary and bullets were rewritten. Review the result.",
      failedTitle: "Couldn't enhance this CV",
      failedBody: "Something went wrong. Please try again.",
      aiUnavailable:
        "AI enhancement is temporarily unavailable. Please try again in a few minutes.",
    },
    // B02: a save based on an older version of the CV (shown once per save).
    conflict: {
      title: "This CV changed on another device or tab",
      messageField:
        "Your change is still here. Apply it on top of the latest version, or discard it and keep the version saved there.",
      messageSection:
        "Your change is still here. Applying it replaces this whole section with your version, so any changes made there to this section are lost. Discard it to keep the version saved there.",
      messageConfig:
        "Your change is still here. Applying it replaces the CV design (layout, color, photo and share card) with yours, so any design changes made there are lost. Discard it to keep the version saved there.",
      apply: "Apply my change on top",
      discard: "Discard my change",
      keepEditing: "Keep editing",
    },
    setup: {
      label: "set up",
      progress: "{{percent}}% set up",
      title: "Complete your CV",
      openHint: "Opens your CV setup checklist",
      optional: "Optional",
    },
    health: {
      control: "CV Health",
      controlA11y: "CV Health, {{status}}",
      checkThisCv: "Check this CV",
      checkAgain: "Check again",
      checking: "Checking…",
      looksGood: "Looks good",
      suggestions_one: "{{count}} suggestion",
      suggestions_other: "{{count}} suggestions",
      introNoReport:
        "Check this CV to see what recruiters, hiring systems and AI tools can read.",
      cvChanged: "Your CV changed. Let's check the latest version.",
      saved: "Saved",
      undone: "Change undone",
      checkingChanges: "Checking the changes…",
      updated: "Updated",
      done: "Done",
      saveFailed: "Your changes haven't been saved yet.",
      trySavingAgain: "Try saving again",
      keepEditing: "Keep editing",
      discardChanges: "Discard changes",
      unsavedTitle: "Discard your edits?",
      close: "Close CV Health",
      openHint: "Opens the CV Health report for this CV",
      addLinkTitle: "Add a professional link",
      invalidLink: "That doesn't look like a valid link.",
    },
    resumeImportNotice: {
      updatedTitle: "Resume imported",
      updatedBody: "Your CV is updated. Review it or create a tailored CV.",
      expiredTitle: "Resume link expired",
      expiredBody:
        "That landing-page handoff has expired. Your CV is still ready here, and you can upload another resume anytime.",
      failedTitle: "Resume import needs attention",
      failedBody:
        "We could not finish that import. You can keep working from your CV, create a tailored version, or try another upload.",
      createTailored: "Create tailored CV",
      uploadAnother: "Upload another resume",
      reviewCv: "Review CV",
      dismiss: "Dismiss",
    },
    resumeImport: {
      tailoredAction: "Replace this CV",
      tailoredActionHint: "Replace this CV only",
      thisCv: "this CV",
      // The tailored CV the import would replace could not be loaded.
      loadFailed: "We couldn't load this CV.",
      tailoredReplaceWarning: "Only {{name}} will be replaced.",
      tailoredConfirmTitle: "Replace {{name}}?",
      tailoredConfirmMessage: "Replace this CV's content with the reviewed resume? Its photo, theme, public link and settings will stay the same.",
      tailoredSuccessMessage: "This CV was replaced with the new resume details.",
      conflict: "This CV changed while you were importing. Reopen the import and review it again before replacing.",
      title: "Update resume",
      pageTitle: "Upload a new resume",
      pageSubtitle:
        "Upload a PDF, DOC, DOCX, TXT, JPG, or PNG resume, or paste resume text.",
      placeholder: "Paste resume text or attach a file",
      replaceWarning: "This replaces your main CV.",
      updateAction: "Update resume",
      updateActionHint:
        "Replace your main CV by uploading or pasting a new resume.",
      updateEntireAction: "Update resume",
      updateEntireActionHint: "Replace main CV",
      failedTitle: "Import failed",
      failedMessage:
        "Could not update your CV. Try another file or paste the resume text.",
      successTitle: "CV updated",
      successMessage: "Your main CV was replaced with the new resume details.",
      cancel: "Cancel",
      confirmTitle: "Replace master CV?",
      confirmMessage: "This replaces your main CV with the new resume.",
      // Shown with confirmMessage when the file was parsed WITHOUT AI.
      exactExtractionNote:
        "Our AI writer was unavailable, so the exact details from the file will be used without rewriting.",
      // The server (or the app) refused a replacement that would have emptied
      // the current CV (incident 2026-09-02).
      replacementIncomplete:
        "We couldn't read work experience, education, or certifications from this file, so your current CV was kept unchanged. Try another file or paste the CV text.",
      replace: "Replace",
      sourceImported: "Resume imported",
      viewSource: "Source",
      revertToSource: "Revert",
      revertConfirm: "This replaces your main CV with the original import.",
      revertSuccessTitle: "CV restored",
      revertSuccessMessage:
        "Your master CV was restored from the original import.",
      noPreviousBackupTitle: "Nothing to restore",
      noPreviousBackupMessage:
        "There's no earlier CV to restore. A backup is only kept when you import a new resume over an existing CV.",
    },
    tailored: {
      title: "Tailored CVs",
      subtitle: "Customized CVs for specific jobs",
      create: "New Tailored CV",
      createTitle: "Create CV",
      cvName: "CV Name",
      cvNamePlaceholder: "e.g., Backend Engineer - Google",
      sourceLabel: "Source",
      sourceAi: "Generate with AI",
      sourceUpload: "Upload resume",
      sourceBlank: "Start blank",
      aiPromptLabel: "Target role or job description",
      aiPromptPlaceholder:
        "Paste a job description or describe the role you want to target. We will tailor your headline, summary, and skills from your current CV.",
      generateWithAi: "Generate with AI",
      titleRequired: "Add a CV name first",
      promptRequired: "Add at least a short target role or job description.",
      generateFailedTitle: "Could not generate CV",
      generateFailedMessage:
        "Try again with a clearer role or job description.",
      createFailedTitle: "Could not create CV",
      createFailedMessage: "Try again with a CV name or recipient name.",
      blankHint:
        "Start with an empty CV, then add sections manually in the editor.",
      createBlank: "Create blank CV",
      uploadTitle: "Upload resume first",
      uploadSubtitle:
        "This updates your main CV from the resume, then creates a tailored CV from the refreshed profile.",
      uploadPlaceholder: "Paste resume text or attach a resume",
      importDefaultTitle: "Imported resume CV",
      importFailedTitle: "Resume import failed",
      importFailedMessage:
        "Could not import this resume. Try another file or paste the resume text.",
      importSuccessTitle: "Tailored CV created",
      importSuccessMessage:
        "Your main CV was refreshed and a tailored CV was created.",
      someoneElse: {
        recipientName: "Recipient name",
        recipientNamePlaceholder: "e.g., Amina Hassan",
        recipientEmail: "Recipient email",
        recipientEmailPlaceholder: "name@example.com",
        delivery: "Delivery",
        copy: "Send a copy",
        transfer: "Transfer",
        defaultTitle: "{{name}} CV",
      },
      emptyTitle: "No tailored CVs yet",
      emptySubtitle: "Create a customized CV for each job application",
      deleteConfirm: "Delete this tailored CV?",
      defaultLabel: "Main",
      setDefault: "Make main",
      defaultSaved: "Main CV updated",
      defaultFailed: "Could not update main CV",
      toolbar: {
        editCv: "Edit CV",
        tailored: "Tailored",
        updateResume: "Update resume",
        customize: "Customize",
        shareWebCv: "Share CV",
      },
    },
  },

  // Jobs
  jobs: {
    title: "Jobs",
    subtitle:
      "For You ranks jobs to your profile. Market shows the wider catalog.",
    detail: "Job Detail",
    handoff: {
      opening: "Opening job…",
      signInRequired: "Sign in to view this job and apply.",
      openingJoin: "Opening talent network…",
      signInRequiredJoin: "Sign in to join this company's talent network.",
    },
    loadingDetail: "Loading job detail",
    loadMore: "Load more jobs",
    searchPlaceholder: "Describe the job you want",
    clearSearch: "Clear job search",
    applyOnWebsite: "Apply on website",
    externalApplyHint: "You’ll continue on the employer’s website.",
    detailHeader: "Job",
    sourceAttribution:
      "Found via {{source}}. Tabbio collects this listing; applying takes you to the original site.",
    gatheredFrom: "Gathered from LinkedIn, Bayt, Indeed & company sites",
    sectionTopPicksTitle: "Top picks for you",
    sectionTopPicksSubtitle: "Based on your CVs, preferences, and saved jobs",
    sectionMoreJobsTitle: "Browse the market",
    sectionMoreJobsSubtitle: "More listings beyond your top matches",
    proCardTitle: "Hear back faster with Tabbio Pro",
    proCardSubtitle:
      "See which jobs are actively reviewing applicants and how you match each one",
    popupBlockedTitle: "Pop-up blocked",
    popupBlockedSubtitle:
      "Allow pop-ups for this site to continue to the employer’s application page.",
    noApplyTargetTitle: "Apply unavailable",
    noApplyTargetSubtitle:
      "This job can’t be applied to right now. Check back later or try another role.",
    noApplyTargetLabel: "Apply unavailable",
    inactiveTitle: "This job is no longer accepting applications",
    inactiveSubtitle:
      "You’re viewing the historical listing saved with your notification.",
    inactiveAction: "Applications closed",
    trackRedirectFailedTitle: "We couldn’t record this application",
    trackRedirectFailedSubtitle:
      "If you finished applying, mark it manually from Applied jobs.",
    catalog: {
      source: {
        tabbioNative: "Tabbio",
        googleJobs: "Google Jobs",
        workable: "Workable",
        linkedin: "LinkedIn",
        bayt: "Bayt",
        naukrigulf: "NaukriGulf",
        partnerAts: "Company ATS",
        external: "External",
      },
      applyMode: {
        tabbioNative: "1-tap",
        externalRedirect: "Apply on site",
        partnerAtsManaged: "Partner ATS",
      },
      roleTag: "Role: {{role}}",
      cta: {
        // The PRIMARY apply button, not a badge — it has to name the action.
        // The "1-tap" LABEL lives in `applyMode.tabbioNative` above and stays
        // a label; these two are separate keys that merely used to read alike.
        oneTap: "Apply in 1 tap",
        applyOnSite: "Apply on site",
        partnerAts: "Partner ATS",
      },
      kind: {
        native: "Native",
        external: "External",
      },
    },
    tabs: {
      discover: "For You",
      explore: "Market",
      saved: "Saved",
      applied: "Applied",
    },
    shortcuts: {
      preferences: "Preferences",
      myJobs: "My jobs",
      alerts: "Alerts",
      liveRefresh: "Fetch live jobs · {{count}} credits",
    },
    actions: {
      save: "Save job",
      unsave: "Unsave job",
      hide: "Hide job",
      undo: "Undo",
      tailorCv: "Tailor a CV for this job",
    },
    feedback: {
      saved: "Job saved",
      unsaved: "Job removed from Saved",
      hidden: "We will not recommend this again",
      hiddenInline: "Job hidden from your recommendations.",
      restored: "Job restored",
      saveFailed: "Could not update this job",
      hideFailed: "Could not hide this job",
      restoreFailed: "Could not restore this job",
    },
    preferences: {
      title: "Preferences",
      myInterests: "My interests",
      openToWorkTitle: "Open to work",
      openToWorkSubtitle: "Visible to recruiters only",
      jobAlertsTitle: "Job alerts",
      jobAlertsEnabled: "Matching jobs and alerts are on",
      jobAlertsDisabled: "Turn on matching job notifications",
      primaryCvSection: "Primary CV",
      primaryCvTitle: "Primary CV",
      primaryCvSubtitle: "Shown to recruiters. Tap to change",
      customCv: "Custom CV",
      verificationSection: "Verification",
      verificationTitle: "Identity verification",
      verificationLinked: "Verified with UAE PASS",
      verificationUnlinked: "Verify with UAE PASS to add a trusted badge",
      verified: "Verified",
      saved: "Preferences saved",
      saveFailed: "Could not save preferences",
    },
    primaryCv: {
      title: "Primary CV",
      subtitle:
        "Choose the CV recruiters see when they find you. You can change it anytime.",
      saved: "Primary CV updated",
      saveFailed: "Could not update Primary CV",
    },
    alerts: {
      title: "Job alerts",
      subtitle: "Manage matching jobs and notification delivery.",
      defaultRuleTitle: "Top job picks for you",
      defaultRuleSubtitle: "Recommended jobs from your profile and activity",
      enabled: "On",
      disabled: "Off",
      topPicksTitle: "Top job picks for you",
      topPicksSubtitle: "Recommend jobs from your profile and activity.",
      editTitle: "Edit alert",
      allAlerts: "All alerts",
      frequencyLabel: "Alert frequency",
      frequency: {
        daily: "Daily",
        weekly: "Weekly",
      },
      notificationType: "Notification type",
      notification: {
        both: "Email and notification",
        email: "Email",
        notification: "Notification",
      },
      similarJobs: "Notify me of similar jobs",
      similarJobsSubtitle: "When matching searches this alert.",
      saved: "Alert updated",
      saveFailed: "Could not update alert",
      newAlert: "New Alert",
    },
    uaePass: {
      title: "Identity verification",
      unverifiedTitle: "Verify it's really you",
      verifiedTitle: "UAE PASS Verified",
      body: "Confirm your identity with UAE PASS so hirers can trust your CV.",
      verifiedBody:
        "Your account is linked with UAE PASS. Recruiters can see your trusted verification badge.",
      governmentIdentity: "Government-grade identity",
      onTabbio: "On Tabbio",
      since: "since {{date}}",
      cvLastUpdated: "CV last updated",
      notUpdatedYet: "Not updated yet",
      dateUnavailable: "Date unavailable",
      howItWorks: "How verification works",
      hideHowItWorks: "Hide verification details",
      loadFailed: "Could not load your verification details.",
      benefitBadge: "Adds a verified badge to every CV you share.",
      benefitName: "Confirms your legal name with UAE PASS.",
      benefitPrivacy: "Your Emirates ID is never shown to hirers.",
      cta: "Continue with UAE PASS",
    },
    myJobs: {
      title: "My jobs",
      saved: "Saved {{count}}",
      applied: "Applied {{count}}",
      emptySaved: "No saved jobs yet",
      emptySavedSubtitle:
        "Save jobs from For You or Market to compare them later.",
      emptyApplied: "No applications yet",
      emptyAppliedSubtitle: "Jobs you apply to will appear here.",
      statusBadge: "Applied",
      appliedAgo: "Applied {{date}}",
      statusDetail: {
        applied: "No response yet",
        submitted: "No response yet",
        redirected: "In progress",
        not_applied: "Not applied",
        reviewed: "Under review",
        shortlisted: "Shortlisted",
        interview: "Interview scheduled",
        offered: "Offer received",
        rejected: "Not selected",
        withdrawn: "Withdrawn",
      },
      talentNetworks: "Talent networks",
      talentNetworkLabel: "Talent network",
      joinedAgo: "Joined {{date}}",
      networkStatus: {
        active: "Member",
        withdrawn: "Left",
      },
    },
    talentNetwork: {
      title: "Talent network",
      status: "Status",
      joined: "Joined",
      left: "Left",
      withdrawnNotice: "You left this talent network. What you sent stays on record with the company.",
      notFoundTitle: "This membership is no longer available",
      notFoundSubtitle: "Go back to My jobs to see your current talent networks.",
      loadErrorTitle: "Couldn't load your talent networks",
      loadErrorSubtitle: "Check your connection and try again.",
      retry: "Try again",
    },
    tailorCv: {
      working: "Tailoring your CV…",
      progress: "Creating a CV for {{title}} at {{company}}. You can keep reading this job.",
      ready: "Your CV for {{title}} at {{company}} is ready.",
      view: "View tailored CV",
      retry: "Try tailoring again",

      defaultTitle: "Tailored CV for {{title}}",
      prompt:
        "Tailor my CV for the {{title}} role at {{company}}. Use the job description below as context and keep every claim truthful to my existing profile.\n\n{{description}}",
    },
    discoverTitle: "For You",
    discoverSubtitle: "Ranked jobs matched to your profile",
    discoverSubtitleWithFamily: "Jobs aligned with your {{family}} profile",
    exploreTitle: "Market",
    exploreSubtitle: "Browse the wider market across roles and sources",
    appliedTitle: "Applied",
    appliedSubtitle: "Jobs you already applied to",
    related: {
      title: "Related matching jobs",
      subtitle: "Similar roles ranked against your profile and this job.",
      missingChip: "Missing {{skill}}",
    },
    noDiscover: "No matched jobs yet",
    noDiscoverSubtitle:
      "We are still learning your profile. Try Market to browse the wider catalog.",
    noDiscoverProfileSubtitle:
      "No jobs matched your {{family}} profile yet. Try Market or refine your skills.",
    noDiscoverImproveProfile:
      "Add skills and target roles to your profile so we can match the right jobs.",
    noDiscoverImproveProfileCta: "Improve my profile",
    noDiscoverCatalogGap:
      "We could not find a suitable role in your current job locations yet. Review your preferences or fetch fresh listings.",
    noDiscoverPreferencesCta: "Review job preferences",
    noDiscoverFilteredSubtitle:
      "Try clearing one or more filters or switch to Market.",
    emptyTitle: "No jobs to show yet",
    emptySubtitle: "Nothing in our catalog matches your profile right now.",
    emptyProfileSubtitle:
      "Nothing in our catalog matched your {{family}} profile yet.",
    emptyFilteredTitle: "No jobs match these filters",
    emptyFilteredSubtitle:
      "Your filters are narrowing everything out. Clear them to see the full catalog.",
    emptyClearFilters: "Clear filters",
    emptyLiveTitle: "You can search job boards live",
    emptyLiveBody:
      "Search fresh Google Jobs results for your target roles and add any new postings to this feed.",
    emptyFetchCta: "Fetch live jobs",
    emptyFetchingLabel: "Searching job boards…",
    emptyFetchingNote: "This can take up to a minute.",
    emptyFetchCreditNote_one: "Uses {{count}} credit",
    emptyFetchCreditNote_other: "Uses {{count}} credits",
    emptyFetchSuccess_one: "Found {{count}} new job",
    emptyFetchSuccess_other: "Found {{count}} new jobs",
    emptyFetchNoResults: "No new postings right now. Try again later.",
    emptyFetchFailed: "Could not search job boards",
    emptyEditSkillsCta: "Update my skills",
    noExplore: "No jobs in Market",
    noExploreSubtitle:
      "Try a different search or loosen a filter to see more roles.",
    noSaved: "No saved jobs yet",
    noSavedSubtitle: "Save jobs from For You or Market to compare them later.",
    filters: {
      title: "Filters",
      subtitle: "Refine the jobs shown in For You and Market.",
      selected: "Selected filters",
      activeCount: "{{count}} active filter",
      activeCount_other: "{{count}} active filters",
      open: "Open filters",
      openWithCount: "Open filters, {{count}} active",
      location: "Location",
      locationSearchPlaceholder: "Search locations…",
      noLocationsFound: "No locations found",
      useCustom: 'Use "{{value}}"',
      workMode: "Work Mode",
      jobType: "Job Type",
      source: "Source",
      applyMode: "Apply Type",
      easyApply: "1-tap / Easy Apply",
      datePosted: "Date Posted",
      clear: "Clear filter",
      clearAll: "Clear all",
      popular: "Popular",
      abuDhabi: "Abu Dhabi",
      dubai: "Dubai",
      sharjah: "Sharjah",
      ajman: "Ajman",
      rak: "RAK",
      onSite: "On-site",
      hybrid: "Hybrid",
      remote: "Remote",
      fullTime: "Full-time",
      partTime: "Part-time",
      contract: "Contract",
      internship: "Internship",
      today: "Today",
      thisWeek: "This week",
      thisMonth: "This month",
    },
    status: {
      applied: "Applied",
      submitted: "Applied",
      redirected: "In Progress",
      not_applied: "Not applied",
      reviewed: "Reviewed",
      shortlisted: "Shortlisted",
      interview: "Interview",
      offered: "Offered",
      rejected: "Rejected",
      withdrawn: "Withdrawn",
    },
    filterChips: {
      all: "All",
      applied: "Applied",
      inProgress: "In Progress",
    },
    confirmPrompt: {
      title: "Did you finish applying?",
      body: "We opened the application for {{title}} at {{company}}. Let us know how it went so we can keep your list accurate.",
      yesApplied: "Yes, I applied",
      notApplied: "No, I didn't apply",
      askLater: "Ask me later",
      error: "Could not update your application status. Please try again.",
    },
    loading: "Loading jobs…",
    loadError: "Could not load jobs",
    loadErrorSubtitle: "Please try again in a moment.",
    notFound: "Job not found",
    notFoundSubtitle: "This job may have been removed or is no longer active.",
    apply: "Apply",
    applied: "Applied",
    externalApply: "Open external application",
    matchScore: "{{score}}% match",
    appliedOn: "Applied on {{date}}",
    aiTools: {
      title: "AI tools for this role",
      ask: "Ask Tabbio AI",
      askBody: "Open chat with this job context.",
      packet: "Application packet",
      packetBody: "Tailor your CV, cover letter, and prep notes.",
      coverLetter: "Cover letter",
      coverLetterBody: "Draft a focused letter from this posting.",
      interview: "Interview prep",
      interviewBody: "Generate likely questions and answer angles.",
      askPromptTitle: "Help me apply for this job: {{title}} at {{company}}.",
      promptJobIdLabel: "Catalog job ID",
      promptLocationLabel: "Location",
      promptDescriptionLabel: "Job description",
      askPromptInstruction:
        "Use my saved Tabbio profile and CVs for this job. Continue directly with useful next steps, and tailor my CV if I ask for it.",
      packetPrompt:
        "Create a tailored CV and application packet for this role.",
      coverLetterPrompt:
        "Focus on a concise, recruiter-ready cover letter for this role.",
      interviewPrompt:
        "Generate predicted interview questions and strong answer angles.",
    },
    smartApply: {
      title: "SmartApply",
      assist: {
        title: "Apply with Tabbio",
        heading: "Let Tabbio prepare this application",
        body: "Choose a CV for {{title}} at {{company}}. Tabbio will review the employer form with you before anything is filled.",
        cvLabel: "CV for this application",
        noCv: "Create a CV first",
        noteLabel: "Anything Tabbio should know?",
        notePlaceholder: "Optional context for this application only",
        checking: "Checking Tabbio Apply...",
        ready:
          "Tabbio will fill the form and attach this CV. You can edit every answer on the employer form, and Tabbio will never submit for you.",
        connectRequired:
          "Connect the installed extension to your Tabbio account before continuing.",
        installRequired:
          "Install Tabbio Apply to review and fill the employer form from this job.",
        openFailed: "Could not open Tabbio Apply",
        opening: "Opening application...",
        continue: "Continue with Tabbio Apply",
        connect: "Connect Tabbio Apply",
        install: "Get Tabbio Apply",
        manual: "Continue without autofill",
        primary: "Apply with Tabbio",
        nativeBody:
          "Choose a CV and Tabbio will fill the visible employer form directly. You can edit everything afterward.",
        analyze: "Fill application",
        analyzing: "Preparing your application",
        analyzingBody:
          "Tabbio is reading the visible form, preparing answers, and generating your selected CV.",
        fill: "Fill application",
        filling: "Filling application...",
        fillingBody:
          "Tabbio is adding your details, answering available questions, and attaching your CV.",
        retry: "Try reading the form again",
        noFormTitle: "No application form found",
        noFormBody:
          "Open the application form or next step on this page, then try again.",
        formChanged:
          "The employer form changed. Read the current step again before filling.",
        attachFailed:
          "Your details were prepared, but the selected CV could not be attached. Try again before continuing.",
        attachFallbackTitle: "Details filled",
        attachFallbackBody:
          "Tabbio couldn't attach this CV automatically. Tap the CV field and upload it manually before submitting.",
        nothingToFill:
          "Tabbio could not find any fields it can safely fill on this step.",
        nativeCta: "Autofill with Tabbio",
        nativeCtaHint: "Fill the form and attach your CV",
        allowanceRemaining: "{{count}} free autofills left this month",
        allowanceLast: "Last free autofill this month",
        allowancePaid: "Unlimited SmartApply autofill with {{plan}}",
        allowanceUpgradeHint: "Plus and Pro include unlimited autofill.",
        checkingForm: "Checking this page for an application form",
        openEmployerForm: "Open the employer's Apply form first",
      },
      fallbackTitle: "Application",
      fallbackCompany: "the company",
      openToolkit: "Open SmartApply toolkit",
      loading: "Loading application page…",
      webFallbackTitle:
        "SmartApply opens external applications in a browser on web.",
      aiAssist: "AI Assist",
      aiAssistBody: "Ask for answers, next steps, or recruiter-ready wording.",
      applicationPack: "Application packet",
      applicationPackBody:
        "Generate CV fit, cover letter, interview prep, and checklist.",
      externalBrowser: "External browser",
      externalBrowserBody: "Open this page outside Tabbio.",
      translate: "Translate",
      translateBody: "Choose a language for this application page.",
      translateBack: "Back to SmartApply tools",
      translateSheetTitle: "Translate page",
      translateSheetSubtitle: "Choose a language",
      translatePickerHint:
        "The page will reload through Google Translate inside SmartApply.",
      translateLanguages: {
        arabic: "Arabic",
        english: "English",
        urdu: "Urdu",
        hindi: "Hindi",
        persian: "Persian",
        french: "French",
      },
      translateLanguageNative: {
        arabic: "العربية",
        english: "English",
        urdu: "اردو",
        hindi: "हिन्दी",
        persian: "فارسی",
        french: "Français",
      },
      settings: "Settings",
      settingsBody: "Adjust profile and application preferences.",
      aiAssistConfirmTitle: "Ask Tabbio AI about this job?",
      aiAssistConfirmBody:
        "We will open chat with this job attached, so Tabbio AI can help with next steps, cover letters, or interview prep.",
      aiAssistConfirmCta: "Ask AI",
      confirmTitle: "Did you finish applying?",
      confirmBody:
        "Only mark this job as applied if you submitted your application on the employer site.",
      applied: "I applied",
      notApplied: "Not applied",
      keepApplying: "Keep applying",
      confirmFailedTitle: "We couldn’t update this application",
      confirmFailedBody:
        "Please try again after the employer site finishes loading.",
      markedApplied: "Application marked as applied",
      markedNotApplied: "Application kept out of Applied jobs",
      aiAssistPromptTitle: "Help me apply for {{title}} at {{company}}.",
      aiPromptDescriptionLabel: "Job description",
      aiPromptPageLabel: "Application page",
      aiAssistPromptInstruction:
        "Use my saved Tabbio profile and CVs for this external application. Continue directly with useful next steps, CV tailoring, or screening-answer help when I ask.",
      applicationPackPrompt:
        "Create an application packet with a tailored CV, cover letter, interview prep, and screening-answer guidance for this specific role.",
    },
    alignment: {
      strong: "Aligned with your target roles",
      medium: "Aligned with your preferences",
      low: "Low alignment",
    },
    match: {
      title: "Why this job appears",
      family: "Role: {{family}}",
      skills: "Matched skills: {{skills}}",
      missingSkills: "Missing skills: {{skills}}",
      completeness: "Completeness: {{score}}%",
      quality: "Quality flags: {{flags}}",
    },
    quality: {
      no_description: "No description",
      thin_requirements: "Thin requirements",
      low_completeness: "Low completeness",
      no_skill_overlap: "No skill overlap",
      low_confidence: "Low confidence",
      surface_ineligible: "Hidden from Discover",
    },
    noJobs: "No jobs found",
    noJobsSubtitle: "There are no active jobs right now. Check back shortly.",
    noJobsFilteredSubtitle:
      "Try clearing one or more filters to see more roles.",
    noApplied: "No applications yet",
    noAppliedSubtitle: "Jobs you apply to will appear here",
    locationFallback: "Location not specified",
    description: "Description",
    skills: "Skills",
    requirements: "Requirements",
    screeningQuestions: "Screening Questions",
    detailLabels: {
      type: "Job type",
      workMode: "Work model",
      level: "Level",
      location: "Location",
      posted: "Posted",
      source: "Source",
    },
    applySheet: {
      title: "Apply to this job",
      smartCvTitle: "Submit your CV",
      smartCvLabel: "Your CV",
      smartCvBody: "You are applying for the {{jobTitle}} role at {{company}}.",
      // The API stores an immutable `cvSnapshot` on the application row and the
      // employer view reads THAT, never the live CV — so this must not promise
      // that later edits reach the recruiter. They don't.
      smartCvNotice:
        "We send a snapshot of your CV with this application. Edits you make later won’t change the copy the recruiter sees.",
      smartApplyBadge: "SmartApply",
      changeResume: "Change",
      chooseCv: "Choose CV",
      chooseCvHint:
        "Select which tailored CV you want to send with this application.",
      screening: "Screening Questions",
      screeningHint: "Answer every required question before submitting.",
      questionNumber: "Question {{number}}",
      answerPlaceholder: "Write your answer…",
      numberPlaceholder: "Enter a number",
      optionalLabel: "Optional",
      yes: "Yes",
      no: "No",
      updatedOn: "Updated {{date}}",
      noScreening: "No additional screening questions for this role.",
      noCvTitle: "No CV available",
      noCvBody: "Create a tailored CV before submitting this application.",
      createCv: "Create CV",
      submit: "Confirm & Submit Application",
      submitting: "Submitting…",
      submitSuccess: "Application submitted",
      successTitle: "Application sent",
      successBody:
        "Your application for {{jobTitle}} is on its way to {{company}}.",
      successNextTitle: "What happens next",
      successNextReview:
        "{{company}} reviews applications inside Tabbio and will reach out by email.",
      successNextTrack:
        "This application, and the CV snapshot you sent with it, stay in My Jobs.",
      viewApplication: "View in My Jobs",
      submitError: "Could not submit application",
      cancel: "Cancel",
      cvUsed: "Applied with {{title}}",
    },
    // Connect-style consent dialogs (public company page → in-app handoff).
    connectShare: {
      label: "Shared with {{company}}",
      nameLabel: "Name",
      emailLabel: "Email",
      cvLabel: "CV",
    },
    connectApply: {
      title: "Apply to {{jobTitle}}",
      submit: "Apply",
      submitting: "Applying…",
      consent:
        "I agree that Tabbio may process my details and share my name, email, and CV with {{company}} so they can consider my application.",
      successTitle: "Application sent",
      successBody: "{{company}} has received your application for {{jobTitle}}.",
      alreadyAppliedTitle: "Already applied",
      alreadyAppliedBody:
        "You had already applied to this job — {{company}} has your application.",
      viewApplication: "View in My Jobs",
    },
    connectJoin: {
      title: "Join {{company}}'s talent network",
      submit: "Join",
      submitting: "Joining…",
      consent:
        "I agree that {{company}} may keep my profile and submitted CV in their talent network and consider me for later opportunities. I can withdraw at any time from within Tabbio.",
      successTitle: "You're in the network",
      successBody: "{{company}} can now consider you for future opportunities.",
      alreadyActiveTitle: "Already a member",
      alreadyActiveBody: "You're already in {{company}}'s talent network.",
      submitError: "Could not join the talent network",
      loadError: "Couldn't load this company",
      loadErrorSubtitle: "Check your connection and try again.",
    },
    // Server refusals every apply surface can receive (apply sheets, Connect
    // apply and join dialogs). Keyed by API error code in lib/apply-error.ts;
    // unknown codes fall back to the server message.
    applyErrors: {
      cvResolutionFailed:
        "We couldn't read your CV just now, so nothing was sent. Please try again.",
      cvEmpty:
        "This CV has no content to send yet. Choose another CV or add your details, then try again.",
      cvBelongsToClient:
        "This CV belongs to one of your clients, so it can't be used as your own. Choose one of your own CVs.",
      jobExternalOnly:
        "This job takes applications on the employer's own site, not through Tabbio.",
      notAccepting:
        "This company isn't accepting submissions through Tabbio yet.",
    },
  },

  // Candidates / Find Talent
  candidates: {
    title: "Find Talent",
    detailHeaderFallback: "Candidate",
    searchPlaceholder: "Name, title, skill…",
    tabs: {
      browse: "Browse",
      shortlisted: "Shortlisted",
    },
    filters: {
      experience: "Experience",
      location: "Location",
      availability: "Availability",
      junior: "0–2 years",
      mid: "3–5 years",
      senior: "6–10 years",
      executive: "10+ years",
      abuDhabi: "Abu Dhabi",
      dubai: "Dubai",
      sharjah: "Sharjah",
      remote: "Remote",
      immediate: "Immediate",
      twoWeeks: "2 weeks",
      oneMonth: "1 month",
      threeMonths: "3 months",
    },
    status: {
      new: "New",
      contacted: "Contacted",
      interviewing: "Interviewing",
      offered: "Offered",
      rejected: "Rejected",
    },
    view: "View",
    shortlist: "Shortlist",
    shortlistedAction: "Shortlisted",
    match: "{{value}}% match",
    experience: "Experience",
    skills: "Skills",
    about: "About",
    details: {
      availability: "Availability",
      source: "Source",
      activity: "Activity",
      status: "Status",
    },
    noCandidates: "No candidates found",
    noCandidatesSubtitle: "Try adjusting your filters or check back later",
    noShortlisted: "No shortlisted candidates",
    noShortlistedSubtitle: "Candidates you shortlist will appear here",
    shortlistedAgo: "Shortlisted {{time}}",
  },

  // Profile
  profile: {
    title: "Profile",
  },

  // Messages
  messages: {
    title: "Messages",
    emptyTitle: "No messages yet",
    emptySubtitle: "Messages from recruiters and employers will appear here",
  },

  studioTools: {
    copy: "Copy",
    copied: "Copied to clipboard",
    copyFailed: "Could not copy",
    cvScore: {
      title: "CV Score Pro",
      subtitle:
        "Score your CV against a target GCC role, ATS signals, missing evidence, and recruiter risks.",
      outcomeFit: "Indicative GCC fit and ATS readability",
      outcomeProof: "Missing skills, tools, and certs",
      outcomeMoves: "Rewrite moves recruiters can see",
      generate: "Generate CV score",
      rolePlaceholder: "e.g. Senior Accountant",
    },
    coverLetter: {
      title: "Cover Letter",
      subtitle:
        "Turn the role, company, and your evidence into a focused letter you can edit and send.",
      outcomeOpening: "A role-specific opening",
      outcomeEvidence: "Relevant proof from your experience",
      outcomeClose: "A confident, concise close",
      generate: "Generate cover letter",
      rolePlaceholder: "e.g. Senior Accountant",
    },
    interviewPrep: {
      title: "Interview Prep",
      subtitle:
        "Build likely questions, evidence-backed talking points, and a practical preparation plan for this role.",
      outcomeQuestions: "Likely role and company questions",
      outcomeStories: "Evidence-backed answer stories",
      outcomePlan: "A focused preparation plan",
      generate: "Generate interview prep",
      rolePlaceholder: "e.g. Product Manager",
    },
    salaryInsights: {
      title: "Salary Insights",
      subtitle:
        "Estimate a practical GCC salary range, confidence level, and negotiation script.",
      outcomeRange: "Low, median, and high range",
      outcomeConfidence: "Confidence and seniority warnings",
      outcomeScript: "Negotiation script you can edit",
      generate: "Generate salary report",
      rolePlaceholder: "e.g. Backend Engineer",
    },
    applicationPack: {
      title: "Application Pack",
      subtitle:
        "Create the full paid bundle: CV fit, cover letter, screening answers, interview prep, salary, recruiter preview, and checklist.",
      outcomePacket: "CV, letter, salary, prep",
      outcomeAnswers: "Screening answers and recruiter read",
      outcomeChecklist: "Apply checklist before submit",
      generate: "Generate application pack",
      rolePlaceholder: "e.g. Product Manager",
    },
    recruiterPreview: {
      title: "Recruiter Preview",
      subtitle:
        "See how employers may read your profile, visible proof, verified fields, and match risks.",
      outcomeRead: "Recruiter-facing summary",
      outcomeRisks: "Ranking and match risks",
      outcomeEvidence: "Missing evidence to add",
      generate: "Generate recruiter preview",
      rolePlaceholder: "e.g. Sales Director",
    },
    form: {
      inputs: "Inputs",
      context: "Context",
      generating: "Building artifact…",
      role: "Target role",
      company: "Company",
      companyPlaceholder: "e.g. Emirates NBD",
      country: "Country",
      countrySearchPlaceholder: "Search country...",
      seniority: "Seniority",
      seniorityJunior: "Junior",
      seniorityMid: "Mid",
      senioritySenior: "Senior",
      seniorityLead: "Lead",
      jobDescription: "Job description",
      jobDescriptionPlaceholder:
        "Paste the job post, responsibilities, or requirements here",
      notes: "Notes",
      notesPlaceholder:
        "Add visa preference, target tone, gaps to handle, or anything important",
    },
    results: {
      latest: "Latest result",
      empty: "No generated artifact yet",
      emptyTitle: "Generate the first artifact",
      emptyBody:
        "Fill the target role and generate the artifact. Your saved results will appear here.",
      savedArtifact: "Saved Studio artifact",
      cvScore: "CV score",
      overall: "Overall",
      gccFit: "GCC fit",
      ats: "ATS",
      strengths: "Strengths",
      missingSkills: "Missing skills",
      nextActions: "Next actions",
      salary: "Salary report",
      low: "Low",
      median: "Median",
      high: "High",
      marketNotes: "Market notes",
      confidence: "Confidence",
      recruiterPreview: "Recruiter preview",
      profileScore: "Profile score",
      visibleStrengths: "Visible strengths",
      concerns: "Concerns",
      missingEvidence: "Missing evidence",
      questions: "Questions",
      highlights: "Highlights",
      steps: "Steps",
      blockers: "Blockers",
      ready: "Ready",
      needsReview: "Needs review",
    },
    errors: {
      generateTitle: "Could not generate",
      generateBody:
        "Try again with a clearer role, country, or job description.",
    },
  },

  // Cover Letters service
  coverLetters: {
    title: "Cover Letters",
    subtitle: "Generate, edit, and reuse personalized cover letters",
    create: "New cover letter",
    createTitle: "New cover letter",
    createSubtitle: "Tell us where you’re applying: we’ll draft the rest",
    recent: "Recent",
    notFound: "Cover letter not found",
    deleteConfirm: "Delete this cover letter?",
    copied: "Copied to clipboard",
    saved: "Saved",
    regenerated: "Regenerated",
    generateFailedTitle: "Could not generate cover letter",
    generateFailedMessage: "Try again with a clearer role or company.",
    regenerate: "Regenerate",
    edit: "Edit",
    copy: "Copy",
    share: "Share",
    calloutTitle: "Draft a tailored letter",
    calloutBody:
      "Paste a job link or fill in a few details: Tabbio drafts a letter that matches the role.",
    emptyTitle: "No cover letters yet",
    emptySubtitle: "Generate your first letter to fast-track applications.",
    row: {
      meta: "{{role}} · {{company}} · {{tone}}",
    },
    detail: {
      meta: "{{role}} at {{company}}",
    },
    tone: {
      professional: "Professional",
      enthusiastic: "Enthusiastic",
      concise: "Concise",
      storytelling: "Storytelling",
    },
    form: {
      company: "Company",
      companyPlaceholder: "e.g. Stripe",
      role: "Role",
      rolePlaceholder: "e.g. Senior Product Designer",
      tone: "Tone",
      notes: "Notes (optional)",
      notesPlaceholder:
        "Share what makes you a great fit, links, or anything you want highlighted",
      generate: "Generate with AI",
    },
  },

  // Interview Prep service
  interviewPrep: {
    title: "Interview Prep",
    subtitle: "Practice with AI and get feedback before the real thing",
    startNew: "Start a session",
    createTitle: "New interview session",
    createSubtitle:
      "Pick a track, tell us the role, and we’ll draft the questions.",
    notFound: "Session not found",
    deleteConfirm: "Delete this session?",
    generateFailedTitle: "Could not create interview prep",
    generateFailedMessage: "Try again with a clearer role or company.",
    answered: "Answered",
    skip: "Skip",
    submitAndNext: "Submit & next",
    finish: "Finish session",
    scoring: "Scoring…",
    showHint: "Show coaching hint",
    hideHint: "Hide hint",
    yourAnswer: "Your answer",
    answerPlaceholder: "Speak it out loud, then type the gist here…",
    feedbackTitle: "Coach feedback",
    questionLabel: "Question {{index}} of {{total}}",
    allQuestions: "All questions",
    heroBadge: "AI Interview coach",
    heroTitle: "Practice the next round",
    heroSubtitle:
      "Choose a track, run a 30-minute session, and get feedback on every answer.",
    sections: {
      tracks: "Tracks",
      recent: "Recent sessions",
    },
    tracks: {
      behavioral: {
        title: "Behavioral",
        subtitle: "STAR-style stories on leadership, ownership, conflict.",
      },
      technical: {
        title: "Technical",
        subtitle: "Coding, debugging, and architecture warm-ups.",
      },
      systemDesign: {
        title: "System design",
        subtitle: "Whiteboard-style high-level design rounds.",
      },
      screening: {
        title: "Phone screen",
        subtitle: "Quick intro, motivation, and fit questions.",
      },
    },
    kind: {
      behavioral: "Behavioral",
      technical: "Technical",
      systemDesign: "System design",
      screening: "Phone screen",
    },
    kindDesc: {
      behavioral: "Stories about leadership and judgment.",
      technical: "Coding and architecture warm-ups.",
      systemDesign: "Whiteboard-style design questions.",
      screening: "Intro and fit checks.",
    },
    status: {
      draft: "Draft",
      in_progress: "In progress",
      completed: "Completed",
    },
    row: {
      progress: "{{answered}}/{{total}} answered",
    },
    form: {
      kind: "Track",
      role: "Role",
      rolePlaceholder: "e.g. Senior Product Manager",
      company: "Company (optional)",
      companyPlaceholder: "e.g. Stripe",
      duration: "Duration",
      minutes_one: "{{count}} min",
      minutes_other: "{{count}} min",
      start: "Start session",
    },
    feedback: {
      short:
        "Solid start: go one layer deeper. Add the specific tradeoff and the metric.",
      tighten:
        "Strong content. Tighten it: cut the middle paragraph and lead with the result.",
      solid:
        "Clear and structured. Land it with a sharper closing line: what changed because of you?",
    },
    toasts: {
      next: "Saved. Next question.",
      completed: "Session complete. Review your feedback.",
    },
  },
  searchArea: {
    title: "Location & range",
    searchPlaceholder: "Search for a city, area or address",
    useCurrent: "Use my current location",
    confirm: "CONFIRM LOCATION",
    distanceTitle: "Maximum distance from your location",
    distanceHelper:
      "Jobs within {{km}} km appear first. Listings further out continue below.",
    preferredLocations: "Preferred Locations",
    add: "Location",
    addAnother: "Add another",
    helper: "This radius is also used to rank Find Jobs → For You.",
    furtherDivider: "Jobs from further away",
    furtherHelper:
      "Past your {{km}} km preference: still strong matches, just farther out.",
    setLocationTitle: "Set a preferred location to rank jobs",
    setLocationCta: "Choose location",
    distanceFrom: "{{km}} km away",
    saveFailedTitle: "Could not save location",
    saveFailedSubtitle: "Check your connection and try again.",
    withinHint: "Within {{km}} km of {{city}} shown first.",
    map: "Map",
    satellite: "Satellite",
    centerOnPin: "Center on pin",
  },
  cvAnalytics: {
    historyWindow: 'Older history keeps daily counts. Named activity and distinct visitors cover the most recent {{days}} days.',
    recruiterViewsLine_one: "{{count}} recruiter view",
    recruiterViewsLine_other: "{{count}} recruiter views",
    recruiterCompanies_one: "from {{count}} company",
    recruiterCompanies_other: "from {{count}} companies",
    recruiterSearchesLine_one: "You appeared in {{count}} recruiter search",
    recruiterSearchesLine_other: "You appeared in {{count}} recruiter searches",
    keywordsTitle: "Keywords recruiters searched",
    keywordsEmpty:
      "No recruiter searches yet. Stay discoverable and keep your skills up to date so employers can find you.",
    keywordsPending: "Keywords appear here once more than one company has searched them.",
    keywordSearches_one: "{{count}} search",
    keywordSearches_other: "{{count}} searches",
    keywordViews_one: "{{count}} view",
    keywordViews_other: "{{count}} views",
    whereFrom: "Where they are from",
    howFound: "How they found you",
    emptyBreakdown: "No breakdown available yet.",
    metric: {
      views: "Views",
      downloads: "Downloads",
      shares: "Shares",
    },
    trend: {
      newLabel: "New",
      new_one: "New in the last {{count}} day",
      new_other: "New in the last {{count}} days",
      up_one: "Up {{percent}}%: last {{count}} day vs the day before",
      up_other: "Up {{percent}}%: last {{count}} days vs the {{count}} days before",
      down_one: "Down {{percent}}%: last {{count}} day vs the day before",
      down_other: "Down {{percent}}%: last {{count}} days vs the {{count}} days before",
      flat_one: "No change: last {{count}} day vs the day before",
      flat_other: "No change: last {{count}} days vs the {{count}} days before",
    },
    activityAction: {
      views: "Viewed your CV",
      downloads: "Downloaded your CV",
      shares: "Shared your CV",
    },
    place: {
      profile: "Your profile",
      shareLink: "Share link",
      tabbio: "On Tabbio",
    },
    filter: {
      all: "All",
      cv: "CV",
      trigger: "Filter analytics",
      group: "Analytics filters",
      duration: "Duration",
      cvVersion: "CV version",
      allCvs: "All CVs",
      mainCv: "Main CV",
      chooseCv: "Choose a CV",
      reset: "Reset",
      days: "{{count}}d",
      done: "Done",
    },
    hub: {
      title: "Analytics",
      close: "Close analytics",
      metricGroup: "Metric",
      chart: "{{metric}} over time",
      chartEmpty: {
        views: "No views in this period",
        downloads: "No downloads in this period",
        shares: "No shares in this period",
      },
      activity: "Activity",
      showMore: "Show more",
      showLess: "Show less",
      privacy: "Private visitors keep their identity hidden.",
      gettingNoticed: "Your CV is getting noticed",
      noRecentActivity: "No recent activity available",
      noActivityYet: "No activity yet",
      stackCaption: "Visitors to your CV",
      viewFullActivity: "View full activity",
      explorePremiumActivity: "Explore Premium for full activity",
      explorePremium: "Explore Premium",
      seeFullActivity: "See your full activity",
      fullActivityPremium: "Detailed activity is included with Premium.",
      viewFullAnalytics: "View full analytics",
      showCv: "Show {{cv}} analytics",
      loading: "Loading analytics",
      errorTitle: "Analytics couldn’t load",
      errorBody: "Try again to see your activity.",
      tryAgain: "Try again",
      moreActivity: "More activity",
      anonymousVisitor: "Anonymous visitor",
      openDetails: "View {{name}} activity details",
      detail: {
        title: "Activity details",
        close: "Close activity details",
        person: "Profile activity",
        company: "Company activity",
        anonymous: "Grouped anonymous activity",
        anonymousTitle: "Anonymous visitors",
        recent: "Recent activity",
        noRecent: "No recent activity in this period",
        companyNote: "Company totals may include more than one visitor. Views inside Tabbio are counted apart from your public CV views.",
        anonymousNote: "These totals combine anonymous activity. Individual visitors cannot be identified.",
        footnote: "Totals count actions, not unique visitors.",
        companyFootnote: "Views count one per company per day.",
        error: "Couldn’t load this activity.",
        gone: "This activity is no longer available.",
      },
    },
    age: {
      minute_one: "{{count}} min",
      minute_other: "{{count}} min",
      hour_one: "{{count}} hr",
      hour_other: "{{count}} hr",
      day_one: "{{count}} day",
      day_other: "{{count}} days",
    },
    liveSummary:
      "{{scope}}, {{period}}. {{views}} views, {{downloads}} downloads, {{shares}} shares.",
    range: {
      lastDays_one: "Last {{count}} day",
      lastDays_other: "Last {{count}} days",
      allTime: "All time",
    },
    source: {
      directLink: "Direct link",
      qr: "QR code",
      copy: "Copied link",
      share: "Share sheet",
      tabbio: "Tabbio",
      email: "Email",
    },
    downloadFormat: {
      print: "Print / PDF",
    },
  },
} as const;
